<template>
  <section>
    <div class="popups">
    <ClientBillingLedgerSidebar
      v-if=orderStorefront
      v-model="showClientBillingLedger"
      :related-id="order.id"
      related-type="StorefrontOrder"
      :brand-id="orderStorefront ? orderStorefront.brandId : null"
      :warehouse-id="orderStorefront ? orderStorefront.warehouseId : null"
      :reference-num="order ? order.orderNumber : null"
    />
      <!-- The modal -->
      <b-modal
        id="order-items"
        v-model="showReshipForm"
        :centered="true"
        size="lg"
        title="ReShip"
        :no-close-on-backdrop="true"
      >
        <b-form-group label="Why?">
          <b-form-select v-model="reshipReason" :options="reshipReasonsList" />
        </b-form-group>
        <!-- <b-form-group label="Do Full Reship?" v-if="reshipReason != 'Other'">
          <b-form-select v-model="doFullReship">
            <option :value="true">
              Yes
            </option>
            <option :value="false">
              No
            </option>
          </b-form-select>
        </b-form-group> -->

        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              type="submit"
              variant="primary"
              class="ml-2 float-right"
              @click.prevent="OrderReshipConfirm"
            >
              Continue to Next Step
            </b-button>
            <b-button
              type="submit"
              variant="secondary"
              class="ml-2 float-right"
              @click="showReshipForm = false"
            >
              Cancel
            </b-button>
          </div>
        </template>
      </b-modal>
      <!-- Edit On Hold Reason Modal -->
      <b-modal
        id="edit-onhold-reason-modal"
        v-model="showEditOnHoldReasonModal"
        :centered="true"
        size="md"
        title="Edit On Hold Reason"
        :no-close-on-backdrop="true"
      >
        <b-form-group label="On Hold Reason">
          <b-form-select v-model="selectedOnHoldReason" :options="onHoldReasonOptions" />
        </b-form-group>

        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              type="submit"
              variant="primary"
              class="ml-2 float-right"
              @click.prevent="updateOnHoldReason"
              :disabled="updatingOnHoldReason"
            >
              <span v-if="updatingOnHoldReason">
                <i class="fa fa-spinner fa-spin"></i> Updating...
              </span>
              <span v-else>Update</span>
            </b-button>
            <b-button
              type="submit"
              variant="secondary"
              class="ml-2 float-right"
              @click="showEditOnHoldReasonModal = false"
            >
              Cancel
            </b-button>
          </div>
        </template>
      </b-modal>
      <!-- Manage Tags Modal -->
      <b-modal
        id="edit-tags-modal"
        v-model="showEditTagsModal"
        :centered="true"
        size="md"
        title="Manage Tags"
        :no-close-on-backdrop="true"
      >
        <div>
          <label class="small font-weight-bold mb-1">Current Tags</label>
          <div class="mb-3 order-details-taglist">
            <span v-if="!editTagsForm.tagIds.length && !editTagsForm.newTags.length" class="text-muted small">No tags applied.</span>
            <span
              v-for="tid in editTagsForm.tagIds"
              :key="tid"
              class="badge mr-1 mb-1 p-2"
              :style="{ backgroundColor: tagColorById(tid), color: '#fff' }"
            >
              {{ tagNameById(tid) }}
              <a href="#" class="text-white ml-1" @click.prevent="removeTagFromForm(tid)">&times;</a>
            </span>
            <span
              v-for="(nt, idx) in editTagsForm.newTags"
              :key="'newtag-' + idx"
              class="badge mr-1 mb-1 p-2"
              :style="{ backgroundColor: nt.color, color: '#fff' }"
            >
              {{ nt.name }}
              <span class="badge badge-light ml-1">new</span>
              <a href="#" class="text-white ml-1" @click.prevent="removeNewTag(idx)">&times;</a>
            </span>
          </div>

          <b-form-group label="Add tag">
            <b-form-select v-model="editTagsAddSelected" :options="addTagOptions">
              <template #first>
                <b-form-select-option :value="''" disabled>— Select a tag to add —</b-form-select-option>
              </template>
            </b-form-select>

            <div v-if="isCreatingNewTag" class="form-row align-items-end mt-2">
              <div class="col-9">
                <b-form-input
                  v-model="editTagsNewName"
                  placeholder="New tag name"
                  @input="val => (editTagsNewColor = val && val.trim() ? palletColorGen(val.trim()) : '#6c757d')"
                />
              </div>
              <div class="col-3">
                <b-form-input v-model="editTagsNewColor" type="color" />
              </div>
            </div>

            <b-button
              block
              variant="outline-primary"
              class="mt-2"
              :disabled="!canAddTag"
              @click="addSelectedTag"
            >
              <i class="fa fa-plus"></i> Add
            </b-button>
          </b-form-group>
        </div>

        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              type="submit"
              variant="primary"
              class="ml-2 float-right"
              :disabled="savingTags"
              @click.prevent="saveTags"
            >
              <span v-if="savingTags">
                <i class="fa fa-spinner fa-spin"></i> Saving...
              </span>
              <span v-else>Save</span>
            </b-button>
            <b-button
              type="submit"
              variant="secondary"
              class="ml-2 float-right"
              @click="showEditTagsModal = false"
            >
              Cancel
            </b-button>
          </div>
        </template>
      </b-modal>
      <div v-if="splitOrderInf">
          <split-order-sidebar
          :prefillOrder="true"
          :key="splitOrderInf.id"
          :order.sync="splitOrderInf"
          :showSplitForm.sync="showSplitForm">
        </split-order-sidebar>
      </div>
      <b-modal
        id="order-items"
        v-model="showShipmentItemsModal"
        :centered="true"
        size="xl"
        title="Shipment Details"
      >
        <div v-if="activeShipment">
          <b-form-group label="Tracking Updates:">
            <TrackingEvents :events="activeShipment.events" max-height="300px" />
          </b-form-group>
        </div>

        <div v-if="shipmentItems && shipmentItems.length">
          <b-table
            class="m-0"
            :striped="true"
            :bordered="true"
            :outlined="true"
            :small="false"
            :hover="false"
            :dark="false"
            :responsive="true"
            :items="shipmentItems"
            head-variant="dark"
            :fields="shipmentItemsFields"
          >
            <template v-slot:cell(fullfillInfo)="data">
              <div
                v-if="data.item.fulfillmentInfo"
              >
                <div class="border-bottom pb-1 pt-1" v-for="fulfillInfoItem in data.item.fulfillmentInfo" :key=fulfillInfoItem.id>
                  <span>Qty: {{ fulfillInfoItem.quantity }}</span>
                  <span v-if="fulfillInfoItem.lpn" class="badge badge-secondary ml-1">From Pallet ID: {{ fulfillInfoItem.lpn }}</span>
                  <span v-if="fulfillInfoItem.lotNumber" class="badge badge-info ml-1">
                    Lot #: {{fulfillInfoItem.lotNumber}}
                  </span>
                  <span v-if="fulfillInfoItem.expirationDate"  class="badge badge-danger ml-1">
                    Expires: {{fulfillInfoItem.expirationDate | moment('MMMM Do YYYY')}}
                  </span>
                  <span v-if="fulfillInfoItem.serialNumbers && fulfillInfoItem.serialNumbers.length"  class="badge badge-warning ml-1">
                    Serial Numbers:
                    <span  v-for="(fulfillInfoItemSerialNum, key) in fulfillInfoItem.serialNumbers" :key="key">
                      {{fulfillInfoItemSerialNum}},
                    </span>
                  </span>
                </div>
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:cell(sku)="data">
              <div
                v-if="getImageUrlFor(data.item)"
                class="avatar d-block d-lg-inline-block mx-auto"
              >
                <img
                  :src="getImageUrlFor(data.item)"
                  alt=""
                  class="avatar-img pr-0 pr-lg-3 pb-3 pb-lg-0"
                />
              </div>
              <span
                style="font-size: 14px;"
                class="d-block d-lg-inline-block text-center"
                >{{ data.item.sku }}</span>
            </template>
          </b-table>
        </div>
        <div v-else>
          <p class="text-muted mb-0 text-center">No items available.</p>
        </div>

        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              type="submit"
              variant="primary"
              size="mr-2 float-right"
              @click="showShipmentItemsModal = false"
            >
              Close
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- Address Search Modal -->
      <AddressSearchModal
        v-model="showAddressSearchModal"
        :initialAddress="order && order.shipTo ? order.shipTo : {}"
        @confirmed="onAddressSearchConfirmed"
      />

      <!-- Address Validation Result Sidebar -->
      <b-sidebar
        id="address-validation-sidebar"
        v-model="showAddressValidationSidebar"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
        width="420px"
      >
        <template #default="{ hide }">
          <div class="px-3 py-3">
            <b-row class="align-items-center mb-3">
              <div class="col">
                <h5 class="mb-0">Address Validation</h5>
              </div>
              <div class="col-auto">
                <b-button variant="link" class="px-0" @click="hide">
                  <i class="fa fa-times"></i>
                </b-button>
              </div>
            </b-row>

            <div v-if="addressValidationResult">
              <!-- Status badge -->
              <div class="mb-3">
                <span
                  v-if="addressValidationResult.isValid && !addressValidationResult.wasUpdated"
                  class="badge badge-success p-2 font-weight-normal"
                >
                  <i class="fa fa-check-circle mr-1"></i> Address is Valid
                </span>
                <span
                  v-else-if="addressValidationResult.wasUpdated"
                  class="badge badge-warning p-2 font-weight-normal"
                >
                  <i class="fa fa-pencil mr-1"></i> Address was Auto-Corrected
                </span>
                <span v-else class="badge badge-danger p-2 font-weight-normal">
                  <i class="fa fa-exclamation-triangle mr-1"></i> Address Invalid
                </span>
              </div>

              <!-- Old vs new address when corrected -->
              <template v-if="addressValidationResult.wasUpdated">
                <h6 class="text-muted text-uppercase small mb-1">Previous Address</h6>
                <div class="p-2 bg-light rounded small mb-3" v-if="addressValidationResult.oldAddress">
                  <div>{{ addressValidationResult.oldAddress.street1 }}</div>
                  <div v-if="addressValidationResult.oldAddress.street2">{{ addressValidationResult.oldAddress.street2 }}</div>
                  <div>{{ addressValidationResult.oldAddress.city }}, {{ addressValidationResult.oldAddress.stateProvince }} {{ addressValidationResult.oldAddress.postalCode }}</div>
                  <div class="text-muted">{{ addressValidationResult.oldAddress.countryCode }}</div>
                </div>
                <h6 class="text-muted text-uppercase small mb-1">Corrected Address</h6>
                <div class="p-2 border border-success rounded small mb-3" v-if="addressValidationResult.newAddress">
                  <div>{{ addressValidationResult.newAddress.street1 }}</div>
                  <div v-if="addressValidationResult.newAddress.street2">{{ addressValidationResult.newAddress.street2 }}</div>
                  <div>{{ addressValidationResult.newAddress.city }}, {{ addressValidationResult.newAddress.stateProvince }} {{ addressValidationResult.newAddress.postalCode }}</div>
                  <div class="text-muted">{{ addressValidationResult.newAddress.countryCode }}</div>
                </div>
                <b-button variant="outline-primary" size="sm" @click="loadItem(); hide()">
                  <i class="fa fa-refresh mr-1"></i> Reload Order
                </b-button>
              </template>

              <!-- Candidate addresses (returned when address is invalid and not auto-corrected) -->
              <template v-if="!addressValidationResult.wasUpdated && addressValidationResult.candidates && addressValidationResult.candidates.length">
                <h6 class="text-muted text-uppercase small mb-2 mt-3">Possible Addresses</h6>
                <div
                  v-for="candidate in addressValidationResult.candidates"
                  :key="candidate.id"
                  class="p-2 border rounded small mb-2 cursor-pointer"
                  :class="selectedCandidateId === candidate.id ? 'border-primary bg-light' : ''"
                  style="cursor:pointer"
                  @click="selectedCandidateId = candidate.id"
                >
                  <div class="d-flex align-items-start">
                    <i
                      class="fa mr-2 mt-1"
                      :class="selectedCandidateId === candidate.id ? 'fa-dot-circle-o text-primary' : 'fa-circle-o text-muted'"
                    ></i>
                    <div>
                      <div>{{ candidate.street1 }}</div>
                      <div v-if="candidate.street2">{{ candidate.street2 }}</div>
                      <div>{{ candidate.city }}, {{ candidate.stateProvince }} {{ candidate.postalCode }}</div>
                      <div class="text-muted">
                        {{ candidate.countryCode }}
                        <b-badge v-if="candidate.isResidential" variant="info" class="ml-1">Residential</b-badge>
                      </div>
                    </div>
                  </div>
                </div>
                <b-button
                  variant="primary"
                  size="sm"
                  block
                  class="mt-2"
                  :disabled="!selectedCandidateId || confirmingCorrection"
                  @click="confirmAddressCorrection"
                >
                  <span v-if="confirmingCorrection"><i class="fa fa-spinner fa-spin mr-1"></i> Applying...</span>
                  <span v-else><i class="fa fa-check mr-1"></i> Confirm Correction</span>
                </b-button>
              </template>

              <!-- No candidates and still invalid -->
              <b-alert
                v-if="!addressValidationResult.isValid && !addressValidationResult.wasUpdated && (!addressValidationResult.candidates || !addressValidationResult.candidates.length)"
                variant="danger"
                show
                class="mt-3"
              >
                Address could not be validated and no correction candidates were found.
              </b-alert>
            </div>

            <div v-else class="text-center text-muted py-5">
              <i class="fa fa-spinner fa-spin mr-2"></i> Running validation...
            </div>
          </div>
        </template>
      </b-sidebar>

      <!-- Move to Storefront Sidebar -->
      <b-sidebar
        id="move-storefront-sidebar"
        v-model="showMoveStorefrontSidebar"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
        width="420px"
      >
        <template #default="{ hide }">
          <div class="px-3 py-3">
            <b-row class="align-items-center mb-3">
              <div class="col">
                <h5 class="mb-0">Change Storefront</h5>
              </div>
              <div class="col-auto">
                <b-button variant="link" class="px-0" @click="hide">
                  <i class="fa fa-times"></i>
                </b-button>
              </div>
            </b-row>

            <b-alert show variant="warning" v-if="order.integrationSystem == 3 || order.integrationSystem == 4">
              This will close the current Shopify fulfillment order, move it to the selected storefront location, and re-submit the fulfillment request.
            </b-alert>

            <b-form-group label="New Storefront">
              <b-form-select
                v-model="moveToStorefrontForm.storefrontId"
                :options="moveToStorefrontOptions"
                @change="moveToStorefrontForm.orderGroupId = moveToOrderGroupOptions.length ? moveToOrderGroupOptions[0].value : ''"
              >
                <template #first>
                  <b-form-select-option value="" disabled>— Select a storefront —</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group label="New Order Group">
              <b-form-select
                v-model="moveToStorefrontForm.orderGroupId"
                :options="moveToOrderGroupOptions"
                :disabled="!moveToStorefrontForm.storefrontId"
              >
                <template #first>
                  <b-form-select-option value="" disabled>— Select an order group —</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group label="Reason (optional)">
              <b-form-input
                v-model="moveToStorefrontForm.reason"
                placeholder="Reason for moving..."
              />
            </b-form-group>

            <b-alert v-if="itemsNotStockedCannotMove" show variant="warning" class="mt-3">
              We can't change the ship from location in Shopify. {{ itemsNotStockedErrorMessage }}
            </b-alert>

            <b-form-checkbox
              v-if="itemsNotStockedCannotMove"
              v-model="moveToStorefrontForm.ignoreShopify"
              class="mt-2"
            >
              Move anyway (ignore Shopify)
            </b-form-checkbox>

            <div class="d-flex justify-content-end mt-3">
              <b-button variant="secondary" class="mr-2" @click="hide">Cancel</b-button>
              <b-button
                variant="primary"
                :disabled="!moveToStorefrontForm.storefrontId || !moveToStorefrontForm.orderGroupId || movingToStorefront || (itemsNotStockedCannotMove && !moveToStorefrontForm.ignoreShopify)"
                @click="submitMoveToStorefront(hide)"
              >
                <span v-if="movingToStorefront"><i class="fa fa-spinner fa-spin mr-1"></i> Moving...</span>
                <span v-else>Confirm Move</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div v-if="!order || !order.id" class="mt-3 p-3 alert alert-warning text-center">
      <h3><i class="fa fa-spinner fa-spin mr-2"></i> Loading...</h3>
    </div>
    <section v-else>
      <div class="header">
        <div class="header-body">
          <div class="row align-items-end">
            <div class="col">
              <h1 class="header-title">
                Storefront Order
              </h1>
            </div>
            <div class="col-auto">
              <div class="row align-items-center">

                <div class="col-auto" v-if="projectOfOrder">
                  <span class="small">Storefront</span>
                  <h5><router-link :to="{
                    name: 'Orders.Index.All',
                    query: {
                      projectId: order.projectId
                    }}">{{ projectOfOrder }}</router-link></h5>
                </div>
                <div class="col-auto" v-if="storeOfOrder">
                  <span class="small">Order Group</span>
                  <h5><router-link :to="{
                    name: 'Orders.Index.All',
                    query: {
                      projectId: order.projectId,
                      storeId: order.storeId
                    }}">{{ storeOfOrder }}</router-link></h5>
                </div>
                <div class="col-auto">
                  <span class="small">Source</span>
                  <h5>{{ order.sourcedFrom }}</h5>
                </div>

                <div class="col-auto">
                  <span class="small">Order number</span>
                  <Transition mode="out-in" name="flash-warning" :duration="{ enter: 1000, leave: 0 }">
                    <h5 :key="baseOrder.orderNumber">{{ order.orderNumber }}</h5>
                  </Transition>
                </div>

                <div class="col-auto">
                  <span class="small">Order status</span>
                  <h5>
                    <Transition mode="out-in" name="flash-fade" :duration="{enter: 2000, leave: 0}">
                      <router-link :key="baseOrder.orderStatus" :to="{
                      name: 'Orders.Index.All',
                      query: {
                        projectId: order.projectId,
                        storeId: order.storeId
                      }}" v-if="order.orderStatus == 'on_hold'" v-b-tooltip.hover
                            :title="'Reason: '+ (order.onHoldReason ? (order.onHoldReason + (order.onHoldReasonDetails ? ', Details: ' + order.onHoldReasonDetails : '')) : 'Unknown / External')" v-html="getOrderStatus(order)">
                      </router-link>
                      <router-link :key="baseOrder.orderStatus" :to="{
                      name: 'Orders.Index.All',
                      query: {
                        projectId: order.projectId,
                        orderStatus: order.orderStatus
                      }}" v-else v-html="getOrderStatus(order)" >
                      </router-link>
                    </Transition>
                  </h5>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <b-row>
      <div class="col-12 col-lg-9">
        <b-row>
          <!-- Order details -->
          <div class="col-12 col-md-8">
            <div class="card">
              <div
                class="card-header c-pointer"
                v-b-toggle.order-details-collapse
              >
                <h4 class="card-header-title">Basic info</h4>

                <i class="fa fa-chevron-down"></i>
              </div>

              <b-collapse visible id="order-details-collapse">
                <div class="card-body">
                  <div class="form-row" v-if="editingOrder">
                    <b-col cols="12" md="6">
                      <b-form-group label="Order Number" description="Can contain numbers, letters, dashes or underscores.">
                        <b-form-input
                          v-validate="{ required: true, min: 3, max: 20, alpha_dash: true }"
                          v-model="order.orderNumber"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Order Key" description="Note: Should be the same as order number in general, or left alone. Can contain numbers, letters, dashes or underscores.">
                        <b-form-input
                          v-model="order.orderKey"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>
                    </b-col>
                  </div>
                  <div class="form-row">
                    <b-col cols="12" md="6">
                      <b-form-group label="Customer email">
                        <b-form-input
                          v-model="order.customerEmail"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Customer username" v-if="order.customerUsername">
                        <b-form-input
                          v-model="order.customerUsername"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </div>

                  <hr class="my-2" />
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-group label="Created At">
                        <b-form-input
                          v-if="!order.createDate"
                          value="N / A"
                          :disabled="true"
                        />
                        <b-form-input
                        v-else
                          :value="
                            order.createDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMMM Do YYYY h:mm a')
                          "
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Order Date">
                        <b-form-input
                          :value="
                            order.orderDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMMM Do YYYY h:mm a')
                          "
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Last Modified">
                        <b-form-input
                          :value="
                            order.modifyDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMMM Do YYYY h:mm a')
                          "
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Ship date" v-if="order.shipDate">
                        <b-form-input
                          :value="
                            order.shipDate | moment('add', '0 hours', 'MMMM Do YYYY')
                          "
                          :disabled="true"
                        />
                      </b-form-group>
                      <b-form-group label="Ship date" v-else>
                        <b-form-input
                          value="N / A"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" v-if="order.sourcedFrom == 'ShipStation'">
                      <b-form-group label="Ship by date">
                        <b-form-input
                          v-if="order.shipByDate"
                          :value="
                            order.shipByDate | moment('MMMM Do YYYY')
                          "
                          :disabled="true"
                        />
                        <b-form-input
                          v-else
                          value="N / A"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" v-if="order.autoRemoveFromHoldAt">
                      <b-form-group label="Automatically Removed from Hold At:">
                        <b-form-input
                          v-if="order.autoRemoveFromHoldAt && !order.autoRemoveFromHoldAt.endsWith('Z')"
                          :value="(order.autoRemoveFromHoldAt + 'Z') | moment('MMM Do YY, h:mm a')"
                          :disabled="true"
                        />
                         <div>
                           <countdown v-if="order.removeFromHoldSecsUntil>0" :time="order.removeFromHoldSecsUntil" v-slot="{ days, hours, minutes, seconds }">
                              Time Remaining：{{ days }} days, {{ hours }} hours, {{ minutes }} minutes, {{ seconds }} seconds.
                            </countdown>
                            <span v-else>About to get removed from hold any second! (A minute or two delay possible for ShipStation storefronts)</span>
                         </div>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" v-else-if="order.sourcedFrom == 'ShipStation'">
                      <b-form-group label="Hold until date (ShipStation)">
                        <b-form-input
                          v-if="order.holdUntilDate"
                          :value="
                            order.holdUntilDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMMM Do YYYY')
                          "
                          :disabled="true"
                        />
                        <b-form-input
                          v-else
                          value="N / A"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <hr class="my-2" />

                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-group label="Requested Shipping Method">
                        <b-form-input
                          v-model="order.requestedShippingService"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-group label="Tags" class="order-details-tags">
                        <template #label>
                          <span>Tags</span>
                          <b-button
                            v-if="has('pm.orders.edit')"
                            variant="light"
                            size="sm"
                            class="p-1 px-2 ml-2 align-baseline border"
                            @click="openEditTagsModal"
                            title="Manage Tags"
                          >
                            <i class="fa fa-pencil"></i> Manage
                          </b-button>
                        </template>
                        <span v-if="order.orderTagIds && order.orderTagIds.length" class="order-details-taglist">
                          <span
                            v-for="tagId in order.orderTagIds"
                            :key="tagId"
                            v-html="getTagById(order.projectId, tagId)"
                          />
                        </span>
                        <span v-else>No tags for this order.</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Pricing -->
          <div class="col-12 col-md-4">
            <div class="card">
              <div class="card-header c-pointer" v-b-toggle.pricing-collapse>
                <h4 class="card-header-title">Pricing and payment</h4>

                <i class="fa fa-chevron-down"></i>
              </div>

              <b-collapse visible id="pricing-collapse">
                <div class="card-body">
                  <div class="row" v-if="order.paymentMethod || order.paymentDate" >
                    <b-form-group label="Payment On" v-if="order.paymentDate" class="col-6 small">
                      <b-form-input
                        :value="
                          order.paymentDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMM Do, h:mm a')
                        "
                        :disabled="true"
                      />
                    </b-form-group>

                    <b-form-group label="Payment method" v-if="order.paymentMethod" class="col-6 small">
                      <b-form-input
                        :value="order.paymentMethod ? order.paymentMethod : 'N/A'"
                        :disabled="true"
                      />
                    </b-form-group>
                  </div>
                  <b-form-group label="Product total" class="small">
                    <b-form-input :disabled="true" :value="currencySymbol(order.currency) + itemsTotal" />
                  </b-form-group>

                  <b-form-group label="Shipping amount" class="small">
                    <b-form-input
                      :value="currencySymbol(order.currency) + order.shippingAmount"
                      :disabled="true"
                    />
                  </b-form-group>

                  <b-form-group label="Tax amount" class="small">
                    <b-form-input
                      :value="currencySymbol(order.currency) + order.taxAmount"
                      :disabled="true"
                    />
                  </b-form-group>
                  <b-form-group label="Order total" class="small">
                    <b-form-input
                      :value="currencySymbol(order.currency) + order.orderTotal"
                      :disabled="true"
                    />
                  </b-form-group>
                  <b-form-group label="Amount paid" class="small">
                    <b-form-input
                      :value="currencySymbol(order.currency) + order.amountPaid"
                      :disabled="true"
                    />
                  </b-form-group>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-row>

        <b-row>
          <!-- Bill to -->
          <div class="col-12 col-md-6">
            <div class="card">
              <div class="card-header c-pointer" v-b-toggle.bill-to-collapse>
                <h4 class="card-header-title">Bill to</h4>

                <i v-if="order.billTo" class="fa fa-chevron-down"></i>
              </div>

              <div v-if="order.billTo">
                <b-collapse visible id="bill-to-collapse">
                  <div class="card-body">
                    <div v-if="order.billTo">
                        <b-row>
                          <b-form-group class="col-6" label="Name">
                            <Transition mode="out-in" name="flash-warning" :duration="{ enter: 1000, leave: 0 }">
                              <b-form-input
                                :key="baseOrder.billTo.name"
                                v-model="order.billTo.name"
                                :disabled="!editingOrder"
                              />
                            </Transition>
                          </b-form-group>

                          <b-form-group class="col-6" label="Company">
                            <Transition mode="out-in" name="flash-warning" :duration="{ enter: 1000, leave: 0 }">
                              <b-form-input
                                :key="baseOrder.billTo.company"
                                v-model="order.billTo.company"
                                :disabled="!editingOrder"
                              />
                            </Transition>
                          </b-form-group>
                        </b-row>

                      <b-form-group label="Phone">
                        <b-form-input
                          v-model="order.billTo.phone"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Country">
                            <b-form-input
                              v-model="order.billTo.country"
                              :disabled="!editingOrder"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                          <b-form-group label="State / Region">
                            <b-form-input
                              v-model="order.billTo.state"
                              :disabled="!editingOrder"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Postal code">
                            <b-form-input
                              v-model="order.billTo.postalCode"
                              :disabled="!editingOrder"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                          <b-form-group label="City">
                            <b-form-input
                              v-model="order.billTo.city"
                              :disabled="!editingOrder"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-form-group label="Street Line 1">
                        <b-form-input
                          v-model="order.billTo.street1"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>

                      <b-form-group label="Street Line 2">
                        <b-form-input
                          v-model="order.billTo.street2"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>

                      <b-row>
                      <b-form-group class="col-6" label="Street Line 3">
                        <b-form-input
                          v-model="order.billTo.street3"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>
                        <b-form-group class="col-6" label="Residential">
                          <b-form-input
                            :value="order.billTo.residential ? 'Yes' : 'No'"
                            :disabled="true"
                          />
                        </b-form-group>
                      </b-row>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <div v-else>
                <div class="card-body">
                  <p class="mb-0">Bill to data is not available.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Ship to -->
          <b-col cols="12" md="6">
            <div class="card">
              <div class="card-header c-pointer">
                <h4 class="card-header-title">Ship to</h4>

                <div v-if="order.shipTo && !editingOrder" class="ml-auto mr-2">
                  <AddressValidationBadge :value="order.shipTo.addressVerified" type="lg" />
                  <b-button
                    v-if="orderStorefront.canValidateAddress && (order.orderStatus == 'on_hold' || order.orderStatus == 'awaiting_shipment') && order.shipTo.addressVerified !== 'Address validated successfully'"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    :disabled="validatingAddress"
                    @click="validateShippingAddress"
                  >
                    <span v-if="validatingAddress">
                      <i class="fa fa-spinner fa-spin mr-1"></i> Validating...
                    </span>
                    <span v-else>
                      <i class="fa fa-map-marker mr-1"></i> Try to Validate
                    </span>
                  </b-button>
                </div>
                <i v-if="order.shipTo" v-b-toggle.ship-to-collapse class="fa fa-chevron-down"></i>
              </div>

              <div v-if="order.shipTo">
                <b-collapse visible id="ship-to-collapse">
                  <div class="card-body">
                    <b-row>
                      <b-form-group class="col-6" label="Name">
                        <b-form-input
                          v-model="order.shipTo.name"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>

                      <b-form-group class="col-6" label="Company">
                        <b-form-input
                          v-model="order.shipTo.company"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>
                    </b-row>

                    <b-form-group label="Phone">
                      <b-form-input
                        v-model="order.shipTo.phone"
                        :disabled="!editingOrder"
                      />
                    </b-form-group>

                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Country">
                          <b-form-input
                            v-model="order.shipTo.country"
                            :disabled="!editingOrder"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-form-group label="State / Region">
                          <b-form-input
                            v-model="order.shipTo.state"
                            :disabled="!editingOrder"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Postal code">
                          <b-form-input
                            v-model="order.shipTo.postalCode"
                            :disabled="!editingOrder"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-form-group label="City">
                          <b-form-input
                            v-model="order.shipTo.city"
                            :disabled="!editingOrder"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-form-group label="Street Line 1">
                      <b-input-group>
                        <b-form-input
                          v-model="order.shipTo.street1"
                          :disabled="!editingOrder"
                        />
                        <b-input-group-append v-if="editingOrder">
                          <b-button variant="outline-secondary" @click="openAddressSearchModal" title="Search address with Google Maps">
                            <i class="fa fa-map-marker"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>

                    <b-form-group label="Street Line 2">
                      <b-form-input
                        v-model="order.shipTo.street2"
                        :disabled="!editingOrder"
                      />
                    </b-form-group>

                    <b-row>
                      <b-form-group class="col-6" label="Street Line 3">
                        <b-form-input
                          v-model="order.shipTo.street3"
                          :disabled="!editingOrder"
                        />
                      </b-form-group>

                      <b-form-group class="col-6" label="Residential">
                        <b-form-input
                          :value="order.shipTo.residential ? 'Yes' : 'No'"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-row>

                  </div>
                </b-collapse>
              </div>

              <div v-else>
                <div class="card-body">
                  <p class="mb-0">Ship to data is not available.</p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <!-- Weight -->
          <b-col cols="12" md="6" v-if="order.weight && order.weight.value">
            <div class="card">
              <div class="card-header c-pointer" v-b-toggle.weight-collapse>
                <h4 class="card-header-title">Storefront Weight</h4>

                <i v-if="order.weight" class="fa fa-chevron-down"></i>
              </div>

              <div v-if="order.weight">
                <b-collapse id="weight-collapse">
                  <div class="card-body">
                    <b-row>
                      <b-form-group class="col-12 col-md-6" label="Value">
                        <b-form-input
                          :value="
                            order.weight.value ? order.weight.value : 'N/A'
                          "
                          :disabled="true"
                        />
                      </b-form-group>

                      <b-form-group class="col-12 col-md-6" label="Unit">
                        <b-form-input
                          :value="
                            order.weight.units ? order.weight.units : 'N/A'
                          "
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-row>
                  </div>
                </b-collapse>
              </div>

              <div v-else>
                <div class="card-body">
                  <p class="mb-0">Weight is not available.</p>
                </div>
              </div>
            </div>
          </b-col>
          <!-- Other -->
          <b-col cols="12" md="6" v-if="order.carrierCode || order.serviceCode">
            <div class="card">
              <div class="card-header c-pointer" v-b-toggle.other-collapse>
                <h4 class="card-header-title">Other</h4>

                <i class="fa fa-chevron-down"></i>
              </div>

              <b-collapse id="other-collapse">
                <div class="card-body">
                  <b-row>
                    <div class="col-12 col-md-6">
                      <b-form-group label="Carrier code">
                        <b-form-input
                          :value="order.carrierCode ? order.carrierCode : 'N/A'"
                          :disabled="true"
                        />
                      </b-form-group>
                    </div>

                    <div class="col-12 col-md-6">
                      <b-form-group label="Service code">
                        <b-form-input
                          :value="order.serviceCode ? order.serviceCode : 'N/A'"
                          :disabled="true"
                        />
                      </b-form-group>
                    </div>
                  </b-row>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="card">
              <div class="card-header c-pointer" v-b-toggle.other-collapse>
                <h4 class="card-header-title">Notes</h4>

                <i class="fa fa-chevron-down"></i>
              </div>

              <b-collapse visible id="other-collapse">
                <div class="card-body">
                  <b-row>
                    <div class="col-12 col-md-6">
                      <b-form-group label="Internal notes">
                        <b-form-textarea
                          :value="order.internalNotes ? order.internalNotes : 'N/A'"
                          :disabled="true"
                          rows="5"
                          max-rows="10"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                      <b-form-group label="Customer Note">
                        <b-form-textarea
                          :value="order.customerNotes ? order.customerNotes : 'N/A'"
                          :disabled="true"
                          rows="5"
                          max-rows="10"
                        />
                      </b-form-group>
                    </div>
                  </b-row>
                </div>
              </b-collapse>
            </div>
          </b-col>
          <b-col cols="12" v-if="order.advancedOptions">
              <div class="card">
                <div
                  class="card-header c-pointer"
                  v-b-toggle.advanced-options-collapse
                >
                  <h4 class="card-header-title">Advanced Options</h4>

                  <i class="fa fa-chevron-down"></i>
                </div>

                <div v-if="order.advancedOptions">
                  <b-collapse id="advanced-options-collapse">
                    <div class="card-body">
                      <b-row>
                        <b-form-group label="Parent Split Order" class="col-6">
                          <router-link
                            v-if="order.parentSplitOrderId"
                            target="_blank"
                            :to="{
                              name: 'Common.OrderDetails',
                              query: { id: order.parentSplitOrderId }
                            }"
                            class="btn btn-block btn-info"
                          >
                            View Order
                          </router-link>
                          <router-link
                            v-else-if="order.advancedOptions.parentId"
                            target="_blank"
                            :to="{
                              name: 'Common.OrderDetails',
                              query: { id: (order.projectId + '-' + order.advancedOptions.parentId) }
                            }"
                            class="btn btn-block btn-info"
                          >
                            View Order
                          </router-link>
                          <div v-else>
                            <b-form-input
                              v-if="!order.parentSplitOrderId"
                              value="N / A"
                              :disabled="true"
                            />
                          </div>
                        </b-form-group>

                        <b-form-group label="Parent Reship Order" class="col-6">
                          <b-form-input
                            v-if="!order.parentReshipOrderId"
                            value="N / A"
                            :disabled="true"
                          />
                          <router-link
                          v-else
                            target="_blank"
                            :to="{
                              name: 'Common.OrderDetails',
                              query: { id: order.parentReshipOrderId }
                            }"
                            class="btn btn-block btn-info"
                          >
                            View Order
                          </router-link>
                        </b-form-group>

                        <b-form-group label="Custom field 1" class="col-12 col-md-4">
                          <b-form-input
                            v-model="order.advancedOptions.customField1"
                            :disabled="!editingOrder"
                          />
                        </b-form-group>

                        <b-form-group label="Custom field 2" class="col-12 col-md-4">
                          <b-form-input
                            :value="
                              order.advancedOptions.customField2
                                ? order.advancedOptions.customField2
                                : 'N/A'
                            "
                            :disabled="true"
                          />
                        </b-form-group>

                        <b-form-group label="Custom field 3" class="col-12 col-md-4">
                          <b-form-input
                            :value="
                              order.advancedOptions.customField3
                                ? order.advancedOptions.customField3
                                : 'N/A'
                            "
                            :disabled="true"
                          />
                        </b-form-group>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>

                <div v-else>
                  <div class="card-body">
                    <p class="mb-0">Advanced options are not available.</p>
                  </div>
                </div>
              </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-card v-if="editingOrder"  class="mb-3" header="Order Items" no-body>
              <div class="card-body">
                <div class="items">
                  <b-table
                    head-variant="light"
                    :fields="orderItemFieldsVisible"
                    :items="itemForm.items"
                    :bordered="true"
                  >
                    <template v-slot:cell(sku)="data">
                      <span>{{ data.item.sku }}</span>
                      <div class="d-inline-block ml-1" v-if="getBundleComponents(data.item.id).length">
                        <BundleComponentsBadge :components="getBundleComponents(data.item.id)" :show-label="false" />
                      </div>
                      <div class="small text-muted" v-if="getItemInventory(data.item.id)">
                        Available: <b>{{ getItemInventory(data.item.id).quantityAvailable }}</b>
                        | On demand: <b>{{ getItemInventory(data.item.id).quantityOnDemand }}</b>
                      </div>
                    </template>
                    <template v-slot:cell(quantity)="data">
                        <b-form-input
                          type="number"
                          step="1"
                          key="form-iteminput-quantity"
                          name="form-iteminput-quantity"
                          class="form-control"
                          v-model="data.item.quantity"
                          min="1"
                        />
                    </template>
                    <template v-slot:cell(actions)="data">
                      <div class="text-center">
                        <button
                          class="btn btn-danger mb-1"
                          @click="data.item.id ? RemoveItem(data.item) : RemoveItem2(data.item)"
                        >
                          Remove
                        </button>
                        <div>
                          <b-button
                            v-if="getBundleComponents(data.item.id).length"
                            size="sm"
                            variant="outline-info"
                            class="ml-1"
                            @click="SplitItemIntoComponents(data.item)"
                          >
                            <i class="fa fa-sitemap mr-1" />Split into components
                          </b-button>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div v-if="editThisSku == data.item.sku" class="form-row">
                        <b-form-input v-model="data.item.name" placeholder="Name" required />
                        <b-button variant="secondary" size="sm" @click="editThisSku = ''"><i class="fa fa-save"></i></b-button>
                      </div>
                      <div v-else>
                        <span>{{ data.item.name }}</span>
                        <b-button variant="secondary" size="sm" @click="editThisSku = data.item.sku"><i class="fa fa-edit"></i></b-button>
                      </div>
                    </template>
                    <template v-slot:cell(unitPrice)="data">
                        <b-form-input
                          type="number"
                          step="0.01"
                          key="form-iteminput-unitPrice"
                          name="form-iteminput-unitPrice"
                          class="form-control"
                          v-model="data.item.unitPrice"
                          min="0"
                        />
                    </template>
                    <template v-slot:cell(unitWeightOz)="data">
                        <b-form-input
                          type="number"
                          step="0.01"
                          key="form-iteminput-unitWeightOz"
                          name="form-iteminput-unitWeightOz"
                          class="form-control"
                          v-model="data.item.unitWeightOz"
                          min="0"
                          :disabled="activeProject && !activeProject.sendWeightsFromStorefront"
                        />
                    </template>
                  </b-table>
                </div>
              </div>
              <template v-slot:footer>
                <form
                  @submit.prevent
                  name="orderChangeItemForm"
                  id="orderChangeItemForm"
                  data-vv-scope="orderChangeItemForm"
                >
                  <div class="alert alert-info p-2" v-if="!itemForm.projectId">
                    <b>Please pick the storefront first in the above form to be able to add products to this order.</b>
                  </div>
                  <div class="alert alert-warning p-2" v-else-if="loadingProductItems">
                    <b>Loading Products, please wait...</b>
                  </div>
                  <div class="form-row" v-else>
                    <div class="col-6 col-md-4">
                      <b-form-group label="Pick Product">
                        <b-v-select
                          key="form-iteminput-productId"
                          v-validate="{ required: true }"
                          name="form-iteminput-productId"
                          :showup="true"
                          v-model="orderChangeItemForm.pickedProduct"
                          :searchable="true"
                          :allowNewValues="false"
                          :options="productsList"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-6 col-md-2">
                      <b-form-group label="Quantity">
                        <b-input-group>
                          <b-form-input
                            type="number"
                            step="1"
                            key="form-iteminput-quantity"
                            v-validate="{
                              required: true,
                              numeric: true,
                              min_value: 1
                            }"
                            name="form-iteminput-quantity"
                            class="form-control"
                            v-model="orderChangeItemForm.quantity"
                            min="1"
                                  />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <div class="col-6 col-md-2">
                      <b-form-group label="Unit Price">
                        <b-input-group>
                          <b-form-input
                            type="number"
                            step="0.01"
                            key="form-iteminput-unitPrice"
                            name="form-iteminput-unitPrice"
                            class="form-control"
                            v-model="orderChangeItemForm.unitPrice"
                            min="0"
                          />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <div class="col-6 col-md-2">
                      <b-form-group label="Unit Weight">
                        <b-input-group>
                          <b-form-input
                            type="number"
                            step="0.01"
                            key="form-iteminput-unitWeightOz"
                            name="form-iteminput-unitWeightOz"
                            class="form-control"
                            v-model="orderChangeItemForm.unitWeightOz"
                            min="0"
                          :disabled="activeProject && !activeProject.sendWeightsFromStorefront"
                          />
                          <template #append>
                            <div class="btn btn-secondary active">oz</div>
                          </template>
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <div class="col-6 col-md-2">
                      <b-form-group label=".">
                        <b-button
                          type="button"
                          block
                          variant="primary"
                          @click="AddOrderItem"
                        >
                          Add
                        </b-button>
                      </b-form-group>
                    </div>
                  </div>
                </form>
              </template>
            </b-card>

            <b-card v-else no-body>
              <template #header class="card-header">
                <h4 class="card-header-title">Order Items</h4>
              </template>

              <b-table
                class="m-0 orderdetails-items-table"
                v-if="order.items && order.items.length > 0"
                :striped="true"
                :bordered="true"
                :outlined="true"
                :small="false"
                :hover="false"
                :dark="false"
                :responsive="true"
                :items="order.items"
                head-variant="dark"
                :fields="fieldsItems"
              >
                <template v-slot:cell(sku)="data">
                  <div
                    v-if="data.item.imageUrl"
                    class="d-inline-block mr-1"
                  >
                    <img
                      :src="data.item.imageUrl"
                      alt=""
                      style="max-width: 50px"
                    />
                  </div>

                  <span
                    style="font-size: 14px;"
                    class="d-block d-lg-inline-block text-center ml-1"
                    >
                    <div class="d-inline-block"  v-if="!has('pm.is_end_partner')">
                      <CopyText :text="data.item.sku">
                        <router-link :to="{name: 'Reports.StorefrontProductStatistics', query: {sku: data.item.sku, projectId: order.projectId}}">
                          <i v-b-tooltip.hover.top="'Fulfill as: ' + data.item.fulfillmentSku" v-if="data.item.fulfillmentSku && data.item.fulfillmentSku != data.item.sku">{{ data.item.sku }}</i>
                          <span v-else>{{ data.item.sku }}</span>
                        </router-link>
                      </CopyText>
                    </div>
                    <div class="d-inline-block"  v-else>
                      <CopyText :text="data.item.sku">
                        <router-link :to="{name: 'apps-reports-storefront-stats', query: {sku: data.item.sku, projectId: order.projectId}}">
                          <i v-b-tooltip.hover.top="'Fulfill as: ' + data.item.fulfillmentSku" v-if="data.item.fulfillmentSku && data.item.fulfillmentSku != data.item.sku">{{ data.item.sku }}</i>
                          <span v-else>{{ data.item.sku }}</span>
                        </router-link>
                      </CopyText>
                    </div>

                      <div class="d-inline-block" :class="{ 'text-danger': true }"
                        v-if="data.item.notEnoughInventory"
                        ><i
                          v-b-tooltip.hover
                          class="fa fa-sort-numeric-asc"
                          title="This order item did not have enough inventory to be fulfilled."
                        />
                      </div>
                      <div class="d-inline-block ml-1" v-if="getBundleComponents(data.item.id).length">
                        <BundleComponentsBadge :components="getBundleComponents(data.item.id)"  :show-label="false" />
                      </div>
                    </span>
                    <div class="small text-muted" v-if="getItemInventory(data.item.id)">
                      Available: <b>{{ getItemInventory(data.item.id).quantityAvailable }}</b>
                      | On demand: <b>{{ getItemInventory(data.item.id).quantityOnDemand }}</b>
                    </div>
                </template>
                <template v-slot:cell(unitPrice)="data">
                  {{ currencySymbol(order.currency) }}{{ data.item.unitPrice }}
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <aside class="col-12 col-lg-3">
        <b-card>
          <template #header class="card-header">
            <h4 class="card-header-title">Actions</h4>
          </template>
          <div class="mb-2" v-if="orderStorefront != null && orderStorefront.fulfillmentViaService != 'ConnectAPI'">
            <div>
              <b-alert show variant="info" v-if="order.orderStatus == 'on_hold'">
                <div>
                  <b>Hold Reason: </b>
                  <span> {{ order.onHoldReason ? order.onHoldReason : 'Unknown / External' }}</span>
                  <b-button
                    v-if="canEditOnHoldReason"
                    :disabled="editingOrder"
                    variant="secondary"
                    size="sm"
                    class="p-0 px-1 ml-2 float-right"
                    @click="openEditOnHoldReasonModal"
                    title="Edit On Hold Reason"
                  >
                    <i class="fa fa-pencil"></i>
                  </b-button>
                </div>
                <div v-if="order.onHoldReasonDetails" class="border-top">
                  <span>{{ order.onHoldReasonDetails }}</span>
                </div>
              </b-alert>
            </div>
            <button
              v-if="
                  order.orderStatus != 'shipped' &&
                  order.orderStatus != 'cancelled' &&
                  (order.orderStatus != 'pending_fulfillment') &&
                  order.orderStatus != 'on_hold'
                  && !order.sentToFulfillService
              "
              @click="PutOnHold(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-warning btn-block"
            >
              Place On Hold
            </button>
            <button
              v-else-if="order.orderStatus == 'on_hold'"
              @click="ReleaseHold(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-warning btn-block"
            >
              Release Hold
            </button>
            <button
              v-if="(order.integrationSystem == 0 || order.integrationSystem == 3 || order.integrationSystem == 4) && order.orderStatus == 'on_hold' && has('pm.orders.edit')"
              @click="openMoveStorefrontSidebar"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-secondary btn-block mt-1"
            >
              Change Storefront
            </button>
            <button
              v-if="
               has('pm.orders.splitOrder') &&
                (order.orderStatus == 'on_hold' && !order.sentToFulfillService)
                && order.items.length > 0
              "
              @click="SplitShipmentOrder(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-info btn-block"
            >
              Split Order
            </button>
            <button
              v-if="has('pm.orders.reship') &&
                (order.orderStatus == 'shipped' ||
                  order.orderStatus == 'cancelled')
              "
              @click="OrderReship(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-info btn-block mb-1"
            >
              Re-Ship Order
            </button>
            <button
              v-if="
              has('pm.orders.cancel') &&
                  projectOfOrder &&
                  order.orderStatus != 'shipped' &&
                  order.orderStatus != 'cancelled' &&
                  (!order.sentToFulfillService || (order.fulfilledByService == 'Crane' || order.fulfilledByService == 'Manual' && !$store.getters['account/hasUserRole']('brand-user')))
              "
              @click="CancelOrder(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-danger btn-block"
            >
              Cancel Order
            </button>

            <button
              v-if="
                !is('brand-user') && has('pm.orders.markShipped') && ((order.orderStatus == 'pending_fulfillment') || order.orderStatus == 'on_hold')
                 && (orderStorefront && orderStorefront.fulfillmentViaService == 'Crane')
              "
              @click="MarkShippedOrder(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-success btn-block"
            >
              Mark Shipped
            </button>
            <button
              v-else-if="
                has('pm.orders.markShipped') &&
                (
                  (
                    (order.orderStatus != 'shipped' || order.orderStatus != 'cancelled') && order.shipCodeMappingDto && order.shipCodeMappingDto.overrideFulfilledByService)
                   ||
                   (
                    (order.orderStatus == 'pending_fulfillment' || order.orderStatus == 'on_hold')
                    && order.fulfilledByService == 'Manual'
                   )
                )
              "
              @click="MarkShippedOrder(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-success btn-block"
            >
              Mark Shipped
            </button>
            <button
              v-if="
                  has('pm.orders.awaitingShip') &&
                  (order.orderStatus == 'pending_fulfillment') && !order.sentToFulfillService
              "
              @click="AwaitShipOrder(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-danger btn-block"
            >
              Place into Awaiting Shipment
            </button>

            <button
              v-if="
              has('pm.orders.undoPending') &&
                orderStorefront &&
                  (order.orderStatus == 'pending_fulfillment' || order.orderStatus == 'on_hold' || order.orderStatus == 'awaiting_shipment') && order.sentToFulfillService &&
                  ((order.fulfilledByService == 'Luxroutage' || order.fulfilledByService == 'Ebix' || order.fulfilledByService == 'TPL' || order.fulfilledByService == 'Manual' || order.fulfilledByService == 'Landmark' || (order.fulfilledByService == 'Crane' && !has('pm.is_end_partner'))) || (order.fulfilledByService == 'ShipStation' && order.orderStatus == 'awaiting_shipment' && orderStorefront.onlyFulfillShipStationUserId == order.userId))
              "
              @click="ReProcessOrder(order)"
              :disabled="loadingOrderChange || editingOrder"
              class="btn btn-secondary btn-block"
            >
              <span v-if="(order.fulfilledByService == 'ShipStation' && order.orderStatus == 'awaiting_shipment' && orderStorefront.onlyFulfillShipStationUserId == order.userId)">Re-Queue for Fulfillment</span>
              <span v-else>Undo Pending Fulfillment</span>
            </button>
            <div
              class="d-flex mt-1 mb-1"
              v-if="has('pm.orders.edit') &&
                  projectOfOrder &&
                  order.orderStatus == 'on_hold' && editingOrder
              ">
              <div class="d-block w-100 mr-1">
                <button
                  @click="EditOrder()"
                :disabled="loadingOrderChange"
                  class="btn btn-success btn-block"
                >
                  Save Changes
                </button>
              </div>
              <div class="d-block w-100 ml-1">
                <button
                  @click="CancelEditingOrder()"
                :disabled="loadingOrderChange"
                  class="btn btn-outline-danger btn-block"
                >
                  Cancel Changes
                </button>
              </div>
            </div>
            <div class="d-block mt-1 mb-1" v-else-if="has('pm.orders.edit') &&
                    projectOfOrder &&
                    !order.sentToFulfillService &&
                    order.orderStatus == 'on_hold' && !editingOrder
                ">
              <button
                @click="StartEditingOrder()"
              :disabled="loadingOrderChange"
                class="btn btn-success btn-block"
              >
                Edit Order
              </button>
            </div>
            <button
              v-if="has('pm.orders.simulateSunbasket') &&
                  projectOfOrder && projectOfOrder == 'Sunbasket' &&
                  !order.sentToFulfillService &&
                  (order.orderStatus == 'on_hold' || (order.orderStatus == 'cancelled' && order.connectLog.includes('ORDER_ERROR')) )
              "
              @click="SimulateSunbasketOrder()"
              class="btn btn-info btn-block"
              :disabled="loadingOrderChange || editingOrder"
            >
              Validate Order in Sunbasket
            </button>
          </div>
            <b-dropdown
              v-if="has('pm.orders.downloadInvoice') && order.sentToFulfillService"
              split
              :split-href="$store.getters.getAppUrl + '/download/storefront-orders/'+order.id+'/customs-documents?documentType=0'"
              text="Download Customs Docs"
              :disabled="editingOrder"
              variant="outline-secondary"
              block
              class="btn-block"
            >
              <b-dropdown-item :href="$store.getters.getAppUrl + '/download/storefront-orders/'+order.id+'/customs-documents?documentType=0'">
                Both (Invoice + CN23)
              </b-dropdown-item>
              <b-dropdown-item :href="$store.getters.getAppUrl + '/download/storefront-orders/'+order.id+'/customs-documents?documentType=1'">
                Invoice Only
              </b-dropdown-item>
              <b-dropdown-item :href="$store.getters.getAppUrl + '/download/storefront-orders/'+order.id+'/customs-documents?documentType=2'">
                CN23 Customs Declaration Only
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item :href="$store.getters.getAppUrl + '/download/storefront-orders/'+order.id+'/landmark-invoice'">
                Landmark Customs Invoice (old)
              </b-dropdown-item>
            </b-dropdown>
          <router-link
            target="_blank"
            v-if="has('pm.other.systemLogs')"
            :to="{
              name: 'ActionLog',
              query: { orderId: order.id }
            }"
            :event="editingOrder ? '' : 'click'"
            :class="{ disabled: editingOrder }"
            class="btn btn-block btn-outline-info"
          >
            Event Log for Order
          </router-link>
          <b-button
            block
            variant="outline-danger"
            v-if="has('pm.customerBilling.billingEntries')"
            :disabled="editingOrder"
            @click="showClientBillingLedger = true"
          >
            Client: Billing Ledger
          </b-button>
          <router-link
            target="_blank"
            v-if="has('pm.carrierBilling.billingEntries')"
            :to="{
              name: 'Billing.CarrierBillingEntries.Index',
              query: { relatedEntityId: order.id, relatedEntityType: 'StorefrontOrder' }
            }"
            :event="editingOrder ? '' : 'click'"
            :class="{ disabled: editingOrder }"
            class="btn btn-block btn-outline-warning"
          >
            Carrier: Charges
          </router-link>
          <router-link
            :to="{
              name: 'Orders.Index.All'
            }"
            :event="editingOrder ? '' : 'click'"
            :class="{ disabled: editingOrder }"
            class="btn btn-outline-secondary btn-block"
          >
            Back To Orders
          </router-link>

          <b-form-group label="Connect Log" class="mt-2" v-if="has('pm.orders.view.connectLog')">
            <Transition mode="out-in" name="flash-warning" :duration="{ enter: 1000, leave: 0 }">
              <b-form-textarea
                :key="baseOrder.connectLog"
                :value="order.connectLog"
                :disabled="true"
                rows="7"
                max-rows="12"
              />
            </Transition>
          </b-form-group>

          <b-form-group label="SS Assigned To" v-if="orderStorefront && orderStorefront.onlyFulfillShipStationUserId && ssAssignedOfOrder">
            <b-input-group>
              <b-form-input
                :value="ssAssignedOfOrder"
                :disabled="true"
              />
            </b-input-group>
          </b-form-group>
        </b-card>

        <!-- Order Returns Card -->
        <b-card class="mt-3" v-if="has('pm.orderReturns.view') && (order.orderStatus == 'shipped' || order.orderStatus == 'cancelled')">
          <template #header class="card-header">
            <h4 class="card-header-title">Order Returns</h4>
          </template>
          <section>
            <button 
              v-if="is('developer') && (order.orderStatus == 'shipped' || order.orderStatus == 'cancelled')"
              type="button"
              :disabled="loadingOrderChange"
              @click="RequestNewReturn()"
              class="btn btn-warning btn-block"
            >
              Generate Return Label <i class="fa fa-info-o" v-b-tooltip.hover='"Generate a return label"'></i>
            </button>
            <router-link
              v-if="
                (order.orderStatus == 'shipped' || order.orderStatus == 'cancelled') &&
               has('pm.orderReturns.confirmReceived')
              "
              :disabled="loadingOrderChange"
              :to="{ name: 'Storefronts.OrderReturns.ConfirmReturn', params: { orderId: order.id } }"
              class="btn btn-secondary btn-block"
            >
              Confirm New Return
            </router-link>
            <div class="mt-1">
              <!-- Order Returns list--->
                <div v-if="loadingOrderReturns" class="text-center">
                  <i class="fa fa-spinner fa-spin mr-1"></i>
                  Loading returns...
                </div>

                <div v-else-if="orderReturnsError" class="alert alert-danger mb-0">
                  <i class="fa fa-exclamation-triangle mr-1"></i>
                  {{ orderReturnsError }}
                </div>

                <div v-else-if="orderReturns.length === 0" class="text-muted text-center">
                  No returns found for this order
                </div>

                <div v-else>
                  <div
                    v-for="(returnItem, index) in orderReturns"
                    :key="returnItem.id || index"
                    class="mb-1"
                  >
                    <b-card
                      size="sm"
                      class="border-left border-info p-3 mb-1"
                      :id="'return-item-' + index"
                      no-body
                    >
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>Return #{{ returnItem.referenceNum }}</strong>
                          <div class="text-muted small d-flex align-items-left pt-1">
                            <div class="border-right pl-0 pr-1 mr-1 col-auto" v-if="returnItem.receiveDate">
                              <i class="fa fa-calendar"></i>
                              {{ returnItem.receiveDate + 'Z' | moment('MMM Do YY') }}
                            </div>
                            <div class="col-auto pl-0">
                              <i class="fa fa-dropbox"></i>
                              {{ returnItem.itemsCount || (returnItem.items && returnItem.items.length) || 0 }} items
                            </div>
                          </div>
                          <div v-if="returnItem.shipmentLabel">
                            <div v-if="returnItem.shipmentLabel.trackingNumber">
                              <span v-b-tooltip.hover title="Copy tracking number">
                                <CopyText :text="returnItem.shipmentLabel.trackingNumber" />
                              </span>
                              <a
                                v-if="returnItem.shipmentLabel.labelUrl"
                                :href="returnItem.shipmentLabel.labelUrl"
                                target="_blank"
                                class="btn btn-sm btn-outline-primary ml-1"
                                v-b-tooltip.hover
                                title="Download return label"
                              >
                                <i class="fa fa-file-pdf-o"></i>
                              </a>
                              <span
                                v-if="returnItem.shipmentLabel.labelUrl"
                                v-b-tooltip.hover
                                title="Copy return label URL"
                                class="ml-1"
                              >
                                <CopyText :text="returnItem.shipmentLabel.labelUrl">
                                  <i class="fa fa-link"></i>
                                </CopyText>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="text-right">
                          <div><OrderReturnStatusBadge :status="returnItem.status" /></div>
                          <div v-if="has('pm.orderReturns.confirmReceived')">
                            <router-link
                                class="btn btn-sm btn-info mt-1"
                                :to="{
                                  name: 'Storefronts.OrderReturns.Edit',
                                  params: { orderReturnId: returnItem.id }
                                }"
                              >View</router-link>
                          </div>
                        </div>
                      </div>
                    </b-card>

                    <!-- Popover for return details -->
                    <b-popover
                      :target="'return-item-' + index"
                      triggers="hover"
                      placement="left"
                      :title="'Return Details #' + (returnItem.referenceNum)"
                    >
                      <div v-if="returnItem.items && returnItem.items.length">
                        <div v-for="item in returnItem.items" :key="item.id" class="mb-2 border-bottom pb-1">
                          <div class="font-weight-bold">{{ item.sku || item.productSku }}</div>
                          <div class="text-muted small">{{ item.productName || item.name }}</div>
                          <div class="small">
                            <span class="text-danger">Returned: {{ item.quantityReceived }} (sent back: {{ item.quantityToReturn }})</span>
                            <span v-if="item.reason" class="ml-2 text-muted">| {{ item.reason }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-muted">
                        No detailed item information available
                      </div>
                    </b-popover>
                  </div>
                </div>
            </div>
          </section>
        </b-card>
        <div class="card">
          <div
            class="card-header c-pointer"
            v-b-toggle.fulfillment-options-collapse
          >
            <h4 class="card-header-title">Fulfillment Info</h4>

            <i class="fa fa-chevron-down"></i>
          </div>

          <div>
            <b-collapse visible id="fulfillment-options-collapse">
              <div class="card-body">
              <!-- Fulfill Order Button -->
              <div v-if="has('pm.orders.fulfill') && order.sentToFulfillService" class="mb-1">
                <b-button
                  variant="primary"
                  block
                  @click="showFulfillOverlay = true"
                >
                  <i class="fa fa-shipping-fast mr-2"></i>
                   Order Fulfillment
                </b-button>
              </div>
                <div class="form-row">
                  <b-form-group label="Pending Fulfillment" class="col-6 small">
                    <b-form-input
                    size="sm"
                      :value="order.sentToFulfillService ? 'Yes' : 'Not yet'"
                      :disabled="true"
                    />
                  </b-form-group>
                  <b-form-group label="Fulfilled In" class="col-6 small">
                    <b-form-input
                    size="sm"
                      :value="order.fulfilledByService ? (order.fulfilledByService == 'TPL' ? 'Extensiv' : order.fulfilledByService) : 'N / A'"
                      :disabled="true"
                    />
                  </b-form-group>
                  <b-form-group label="Ext. fulfilled by" class="col-12 small" v-if="order.externallyFulfilledBy">
                      <b-form-input
                        :value="
                          order.externallyFulfilledBy
                            ? order.externallyFulfilledBy
                            : 'N/A'
                        "
                        :disabled="true"
                      />
                    </b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-6 small" label="Fulfillment Started At">

                    <b-form-input
                    size="sm"
                      v-if="order.sentFulfillAt && !order.sentFulfillAt.endsWith('Z')"
                      :value="(order.sentFulfillAt + 'Z') | moment('MMM Do YY, h:mm a')"
                      :disabled="true"
                    />
                    <b-form-input
                    size="sm"
                      v-else
                      :value="(order.sentFulfillAt) | moment('MMM Do YY, h:mm a')"
                      :disabled="true"
                    />
                  </b-form-group>

                  <b-form-group class="col-6 small" label="Fulfilled At">

                    <b-form-input
                    size="sm"
                      v-if="order.completedFulfillAt && !order.completedFulfillAt.endsWith('Z')"
                      :value="(order.completedFulfillAt + 'Z') | moment('MMM Do YY, h:mm a')"
                      :disabled="true"
                    />
                    <b-form-input
                    size="sm"
                      v-else
                      :value="(order.completedFulfillAt) | moment('MMM Do YY, h:mm a')"
                      :disabled="true"
                    />
                  </b-form-group>
                </div>

                <b-form-group class="small" label="Fulfillment Order ID" description="The ID of the Order in the Fulfillment Service.">
                  <b-form-input
                    size="sm"
                    :value="
                      order.fulfillmentOrderId
                    "
                    :disabled="true"
                  />
                </b-form-group>
                <div v-if="has('pm.other.shipCodeMappings') && orderStorefront != null && orderStorefront.fulfillmentViaService != 'ConnectAPI'">
                    <router-link
                      target="_blank"
                      v-if="order.shipCodeMappingId"
                      :to="{
                        name: 'Storefronts.ShipCodeMappings.Edit',
                        params: { id: order.shipCodeMappingId }
                      }"
                      class="btn btn-block btn-sm btn-outline-secondary"
                    >
                      View ShipCode Mapping
                    </router-link>
                    <router-link
                      target="_blank"
                      v-else-if="order.possibleShipCodeMappingId"
                      :to="{
                        name: 'Storefronts.ShipCodeMappings.Edit',
                        params: { id: order.possibleShipCodeMappingId }
                      }"
                      class="btn btn-block btn-outline-secondary"
                    >
                      Review Matching ShipCode Mapping
                    </router-link>
                    <button
                      target="_blank"
                      v-else-if="!order.possibleShipCodeMappingId"
                      @click="OpenCreateMappingPage()"
                      class="btn btn-block btn-outline-success"
                    >
                      Create Matching ShipCode Mapping
                    </button>
                </div>
              </div>

              <section class="card-footer" v-if="has('pm.orders.fulfill') && orderStorefront && order.sentToFulfillService && (has('pm.is_lacore_admin') || has('pm.is_lacore_team_member'))">
                <div visible id="carrier-integration-fulfillment">
                </div>
              </section>
            </b-collapse>
          </div>
        </div>

        <div class="card" v-if="orderStorefront && orderStorefront.virtualFulfillmentViaService == 'TPL_MIRRORED' &&
         has('pm.is_lacore_admin')">
          <div
            class="card-header c-pointer"
            v-b-toggle.virtual-fulfullment-options-collapse
          >
            <h4 class="card-header-title">Mirrored Order Info</h4>

            <i class="fa fa-chevron-down"></i>
          </div>

          <div>
            <b-collapse visible id="virtual-fulfullment-options-collapse">
              <div class="card-body">
                <div v-if="has('pm.is_lacore_admin') && order.virtuallyFailedInFulfillService">
                  <button
                    @click="RetryVirtualFulfillOrder(order)"
                    class="btn btn-block btn-warning"
                  >
                    Retry Mirroring Order
                  </button>
                </div>
                <b-form-group label="Mirrored to Virtual Fulfillment Service">
                  <b-form-input
                    :value="order.virtuallySentToFulfillService ? 'Yes' : 'No'"
                    :disabled="true"
                  />
                </b-form-group>

                <b-form-group label="Virtual Fulfillment Service">
                  <b-form-input
                    :value="order.virtuallyFulfilledByService ? (order.virtuallyFulfilledByService == 'TPL' ? 'Extensiv' : order.virtuallyFulfilledByService) : 'N / A'"
                    :disabled="true"
                  />
                </b-form-group>

                <b-form-group label="Mirorred At">
                  <b-form-input
                    v-if="order.virtuallySentFulfillAt && !order.virtuallySentFulfillAt.endsWith('Z')"
                    :value="(order.virtuallySentFulfillAt + 'Z') | moment('MMM Do YY, h:mm a')"
                    :disabled="true"
                  />
                  <b-form-input
                    v-else
                    :value="(order.virtuallySentFulfillAt) | moment('MMM Do YY, h:mm a')"
                    :disabled="true"
                  />
                </b-form-group>

                <b-form-group label="Closed At">

                  <b-form-input
                    v-if="order.virtuallyCompletedFulfillAt && !order.virtuallyCompletedFulfillAt.endsWith('Z')"
                    :value="(order.virtuallyCompletedFulfillAt + 'Z') | moment('MMM Do YY, h:mm a')"
                    :disabled="true"
                  />
                  <b-form-input
                    v-else
                    :value="(order.virtuallyCompletedFulfillAt) | moment('MMM Do YY, h:mm a')"
                    :disabled="true"
                  />
                </b-form-group>

                <b-form-group label="Virtual Fulfillment Order ID" description="The ID of the Order in the Virtual Fulfillment Service.">
                  <b-form-input
                    :value="
                      order.virtuallyFulfillmentOrderId
                    "
                    :disabled="true"
                  />
                </b-form-group>
              </div>
            </b-collapse>
          </div>
        </div>

        <div class="card" v-if="order.subOrders && order.subOrders.length">
          <div
            class="card-header c-pointer"
            v-b-toggle.virtual-suborders-options-collapse
          >
            <h4 class="card-header-title">Related Orders</h4>

            <i class="fa fa-chevron-down"></i>
          </div>

          <div>
            <b-collapse visible id="virtual-suborders-options-collapse">
              <div class="card-body">

                <b-form-group v-for="subOrdr in order.subOrders" :key="subOrdr.orderId"
                :label="'Order ' + subOrdr.orderNumber + ', ' + (subOrdr.type == 'split' ? 'Split via Connect' : (subOrdr.type == 'split-ss' ? 'Split via ShipStation' : 'Reship'))"
                >
                  <router-link
                    target="_blank"
                    :to="{
                      name: 'Common.OrderDetails',
                      query: { id: subOrdr.orderId }
                    }"
                    class="btn btn-block btn-light"
                  >
                    View {{subOrdr.orderNumber}}
                  </router-link>
                </b-form-group>

              </div>
            </b-collapse>
          </div>
        </div>
        <DiscussionsWidget v-bind="chatWidgetProps" v-if="chatWidgetProps.relatedId"></DiscussionsWidget>

        <div class="card" v-if="orderStorefront && order.orderCheckouts != null && order.orderCheckouts.length && (has('pm.orders.checkout.view'))">
          <div
            class="card-header c-pointer"
            v-b-toggle.payment-integration-options-collapse
          >
            <h4 class="card-header-title">Payment Integration</h4>

            <i class="fa fa-chevron-down"></i>
          </div>

          <div>
            <b-collapse visible id="payment-integration-options-collapse">
              <div class="card-body">
                <!-- <div v-if="(has('pm.orders.checkout.create')) && order.orderStatus == 'awaiting_payment'">
                  <button
                    @click="RetryOrderWithCarrier(order)"
                    class="btn btn-block btn-warning"
                  >
                    Generate new Checkout
                  </button>
                </div> -->
                <div v-for="orderCheckout in order.orderCheckouts" :key="orderCheckout.id">
                  <div>
                    <b-form-group label="Checkout URL">
                      <b-input-group>
                        <b-form-input
                          :value="orderCheckout.checkoutUrl"
                          :ref="orderCheckout.id"
                          readonly
                        />
                        <b-input-group-append>
                          <b-button  @click="CopyToClipboard(orderCheckout.id)" size="sm" text="Copy" variant="secondary"><i class="fa fa-copy"></i></b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label="Checkout Status">
                      <b-form-input
                        :value="orderCheckout.status"
                        readonly
                      />
                    </b-form-group>
                  </div>
                  <div class="border-bottom pb-1 mb-1">
                    <b v-if="orderCheckout.paidAtDateTimeUtc">Paid At: {{ orderCheckout.paidAtDateTimeUtc | moment('MMM Do YY, h:mm a') }}</b>
                    <b v-else-if="orderCheckout.status != 'Expired' && orderCheckout.status != 'Cancelled'">Expires At: {{ orderCheckout.expiresAtDateTimeUtc | moment('MMM Do YY, h:mm a') }}</b>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
        <FinanceMarginWidget :id="id"></FinanceMarginWidget>


        <!-- Cartonization Tool: Optimal Packaging Box -->
        <b-card v-if="has('pm.orders.fulfill')" class="mt-3">
          <template #header>
            <h5 class="card-header-title mb-0">
              <i class="fa fa-cube mr-1"></i>
              Cartonization Tool
            </h5>
          </template>
          <div class="text-center" v-if="!optimalBoxResult && !loadingOptimalBox">
            <b-button
              variant="info"
              size="sm"
              @click="getOptimalPackagingBox"
              class="btn-block"
            >
              <i class="fa fa-magic mr-1"></i>
              Calculate Optimal Packaging
            </b-button>
          </div>

          <div class="text-center" v-if="loadingOptimalBox">
            <i class="fa fa-spinner fa-spin"></i>
            <span class="ml-2">Calculating...</span>
          </div>

          <div v-if="optimalBoxResult && !loadingOptimalBox">
            <!-- Summary -->
            <div class="mb-3">
              <div class="d-flex justify-content-between align-items-center">
                <strong>{{ optimalBoxResult.summary }}</strong>
                <span v-if="optimalBoxResult.allItemsPacked" class="badge badge-success">
                  <i class="fa fa-check"></i> Complete
                </span>
                <span v-else class="badge badge-warning">
                  <i class="fa fa-warning"></i> Partial
                </span>
              </div>
              <div class="row small mt-2">
                <div class="col-4 text-center">
                  <strong>Total Items:</strong><br>
                  {{ optimalBoxResult.totalItemsCount }}
                </div>
                <div class="col-4 text-center">
                  <strong>Packed:</strong><br>
                  <span class="text-success">{{ optimalBoxResult.packedItemsCount }}</span>
                </div>
                <div class="col-4 text-center" v-if="optimalBoxResult.unpackedItemsCount > 0">
                  <strong>Unpacked:</strong><br>
                  <span class="text-warning">{{ optimalBoxResult.unpackedItemsCount }}</span>
                </div>
              </div>
            </div>

            <!-- Recommended Boxes -->
            <div class="mb-2">
              <strong>Recommended Boxes: ({{ optimalBoxResult.recommendedBoxes.length }}):</strong>
            </div>
            <div v-for="(box, index) in optimalBoxResult.recommendedBoxes" :key="box.id" class="card mb-2">
              <div class="card-header py-2">
                  <div>
                    <strong>Box #{{ index + 1 }} - {{ box.name }}</strong>
                  </div>
                  <div class="p-0 ml-auto">
                    <b-button
                      v-if="box.items && box.items.length > 0"
                      size="sm"
                      variant="info"
                      @click="toggleOptimalBoxItems(index)"
                      class="p-0 text-decoration-none"
                    >
                      <i :class="optimalBoxItemsExpanded[index] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                      <span class="ml-1">{{ optimalBoxItemsExpanded[index] ? 'Hide' : 'Show' }} Items ({{ box.items.length }})</span>
                    </b-button>
                    <span v-else class="text-muted badge badge-danger small">
                      No items details
                    </span>
                  </div>
              </div>
              <div class="card-body small">
                <div class="row">
                  <div class="col-4">
                    <span class="text-muted">Dimensions:</span><br>
                    {{ box.length }}" × {{ box.width }}" × {{ box.height }}"
                  </div>
                  <div class="col-4">
                    <span class="text-muted">Efficiency:</span><br>
                    <span class="badge badge-info">{{ (box.packingEfficiency * 100).toFixed(1) }}% full</span>
                  </div>
                  <div class="col-4">
                    <span class="text-muted">Items Count:</span><br>
                    {{ box.packedItemsCount }} items
                  </div>
                </div>
                
                <!-- Collapsible Items Section -->
                <b-collapse :id="'optimal-box-items-' + index" v-model="optimalBoxItemsExpanded[index]" class="mt-3">
                  <div class="border-top pt-2">
                    <strong class="d-block mb-2">Packed Items:</strong>
                    <div v-if="box.items && box.items.length > 0">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>SKU</th>
                            <th>Name</th>
                            <th>Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, itemIndex) in box.items" :key="itemIndex">
                            <td><CopyText :text="item.sku" /></td>
                            <td>{{ item.name }}</td>
                            <td class="text-center">{{ item.quantity }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="text-muted">
                      No item details available
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>

            <div class="mt-2">
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="clearOptimalBoxResult"
                class="btn-block"
              >
                <i class="fa fa-refresh mr-1"></i>
                Recalculate Packaging
              </b-button>
            </div>
          </div>

          <div v-if="optimalBoxError" class="alert alert-danger mt-2">
            <i class="fa fa-exclamation-triangle mr-1"></i>
            {{ optimalBoxError }}
          </div>
        </b-card>

      </aside>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card
          v-if="order.shipments && order.shipments.length > 0"
          class="mb-3"
          no-body
        >
          <template #header class="card-header">
            <h4 class="card-header-title">Shipments</h4>
          </template>

          <b-table
            class="m-0"
            :striped="true"
            :bordered="true"
            :outlined="true"
            :small="false"
            :hover="false"
            :dark="false"
            :responsive="true"
            :items="order.shipments"
            head-variant="dark"
            :fields="shipmentFields"
          >

            <template v-slot:cell(status)="data">
              <span  class="badge badge-secondary" v-if="data.item.status == 'Created'">Created</span>
              <span  class="badge badge-warning" v-else-if="data.item.status == 'InTransit'">InTransit</span>
              <span  class="badge badge-info" v-else-if="data.item.status == 'Shipped'">Shipped</span>
              <span  class="badge badge-success" v-else-if="data.item.status == 'Delivered'">Delivered</span>
              <span  class="badge badge-danger" v-else-if="data.item.status == 'Cancelled'">Cancelled</span>
              <span  class="badge badge-danger" v-else-if="data.item.status == 'DamagedInTransit'">Damaged In Transit</span>
              <span  class="badge badge-danger" v-else-if="data.item.status == 'LostInTransit'">LostInTransit</span>
              <span class="badge badge-secondary" v-else>{{ data.item.status }}</span>
              <b-button
                v-if="data.item.status == 'Created' && $store.getters.getAppEnv != 'production'"
                size="sm"
                variant="success"
                class="ml-1"
                :disabled="markingDeliveredShipmentId === data.item.id"
                @click="markShipmentDelivered(data.item)"
              >
                <i v-if="markingDeliveredShipmentId === data.item.id" class="fa fa-spinner fa-spin"></i>
                <span v-else>Mark Delivered</span>
              </b-button>
            </template>
            <template v-slot:cell(trackingNumber)="data">
            <div>
              <span v-if="data.item.trackingUrl"><a target="_blank"
                class="badge"
                  :class="{
                    'badge-danger': data.item.isReturnLabel,
                    'badge-secondary': !data.item.isReturnLabel
                  }"
                :href="data.item.trackingUrl">{{ data.item.trackingNumber }}</a></span>
              <span v-else-if="data.item.trackingNumber">
                <a :href="'https://t.17track.net/en#nums=' + data.item.trackingNumber"
                  target="_blank"
                  class="badge"
                  :class="{
                    'badge-danger': data.item.isReturnLabel,
                    'badge-secondary': !data.item.isReturnLabel
                  }"
                  >{{ data.item.trackingNumber }}</a>
              </span>
              <span v-else>
                <span>{{ data.item.trackingNumber }}</span>
              </span>
            </div>
            <div class="border-top">
              <span class="text-secondary" v-if="data.item.shipDate">Shipped at: {{ data.item.shipDate | moment('MMMM Do YYYY, h:mm a') }}</span>
            </div>
            </template>
            <template v-slot:cell(receiveDate)="data">
              <span v-if="data.item.receiveDate">{{ data.item.receiveDate | moment('MMMM Do YYYY') }}</span>
              <span v-else>-</span>
            </template>

            <template v-slot:cell(carrierCode)="data">
              <div>
                <span v-if="data.item.carrierCode">{{ data.item.carrierCode  }}</span>
                <span v-else>-</span>
              </div>
              <div class="border-top" v-if="data.item.serviceCode">
                <span class="text-secondary">{{ data.item.serviceCode }}</span>
              </div>
            </template>
            <template v-slot:cell(dimensions)="data">
              <div v-if="data.item.dimensions && data.item.dimensions.units">
                <span>W: {{ data.item.dimensions.width }} {{ data.item.dimensions.units }}</span> |
                <span>H {{ data.item.dimensions.height }} {{ data.item.dimensions.units }}</span> |
                <span>L: {{ data.item.dimensions.length }} {{ data.item.dimensions.units }}</span>
              </div>
            </template>

            <template v-slot:cell(weight)="data">
              <div v-if="!is('brand-user') && data.item.weight && data.item.weight.value && data.item.grossWeight && data.item.grossWeight.units && data.item.grossWeight.value && parseFloat(data.item.weight.value) > parseFloat(data.item.grossWeight.value)">
                <b>Gross (DIMW): </b><span>{{ parseFloat(data.item.weight.value).toFixed(2) }}</span> (Orig: <span>{{ parseFloat(data.item.grossWeight.value).toFixed(2) }}</span>) {{ data.item.weight.units }}
              </div>
              <div v-else-if="data.item.weight && data.item.weight.units && data.item.weight.value">
                <b>Gross: </b><span>{{ parseFloat(data.item.weight.value).toFixed(2) }}</span> {{ data.item.weight.units }}
              </div>
              <div class="border-top" v-if="data.item.packagingWeight && data.item.packagingWeight.units && data.item.packagingWeight.value">
                <b>Packaging: </b><span>{{ parseFloat(data.item.packagingWeight.value).toFixed(2) }}</span> {{ data.item.packagingWeight.units }}
              </div>
            </template>

            <template v-slot:cell(fulfilledByService)="data">
              <span
               v-if="data.item.fulfilledByService == 'TPL'"
              >
                <span v-if="!has('pm.is_client')">Extensiv</span>
                <span v-else>LaCore Logistics</span>
              </span>
              <span v-else>
                {{ data.item.fulfilledByService }}
              </span>
            </template>

            <template v-slot:cell(id)="data">
              <button
                class="btn btn-primary"
                @click="ViewShipmentItems(data.item)"
              >
                Details
              </button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    </section>

    <!-- Fulfill Order Overlay -->
    <FulfillOrderOverlay
      :visible.sync="showFulfillOverlay"
      :order="order"
      :brand-id="orderStorefront ? orderStorefront.brandId : ''"
      :warehouse-id="orderStorefront ? orderStorefront.warehouseId : ''"
      @hidden="showFulfillOverlay = false"
      @order-fulfilled="loadItem"
      @label-generated="loadItem"
      @fulfillment-confirmed="loadItem"
    />

  </section>
</template>

<script>
//import vSelect from 'vue-select';
import SplitOrderSidebar from '../../../components/SplitOrderSidebar.vue'
import FulfillOrderOverlay from '../../../components/storefronts/orders/FulfillOrderOverlay.vue'
import FinanceMarginWidget from '@/views/components/FinanceMarginWidget.vue';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import DiscussionsWidget from '@/views/components/DiscussionsWidget';
import AddressValidationBadge from '../../../components/storefronts/orders/AddressValidationBadge.vue';
import BundleComponentsBadge from '../../../components/storefronts/orders/BundleComponentsBadge.vue';
import AddressSearchModal from '../../../components/storefronts/orders/AddressSearchModal.vue';
import ClientBillingLedgerSidebar from '../../../components/ClientBillingLedgerSidebar.vue';
import OrderReturnStatusBadge from '../../../components/OrderReturnStatusBadge.vue';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderDetails',
  components: {
    DiscussionsWidget,
    FinanceMarginWidget: FinanceMarginWidget,
    SplitOrderSidebar,
    FulfillOrderOverlay,
    AddressValidationBadge,
    BundleComponentsBadge,
    AddressSearchModal,
    ClientBillingLedgerSidebar,
    OrderReturnStatusBadge
  },
  // props: {
  //   id: {
  //     type: String,
  //     required: false
  //   }
  // },
  data() {
    return {
      showClientBillingLedger: false,
      chatWidgetProps: {
        startOpen: true,
        channelType: 'FeatureClientSupport',
        relatedDesc: 'Discussion for Order',
        relatedName: 'Storefront Order: ',
        relatedId: '',
        relatedType: 'SO'
      },

      shipStationUsers: [],
      //refreshinItem: '',
      loadingProductItems: false,
      editThisSku: '',
      id: '',
      storeProdsList: [],
      showEditOnHoldReasonModal: false,
      selectedOnHoldReason: '',
      updatingOnHoldReason: false,
      showEditTagsModal: false,
      savingTags: false,
      editTagsForm: {
        tagIds: [],
        newTags: []
      },
      editTagsAddSelected: '',
      editTagsNewName: '',
      editTagsNewColor: '#6c757d',
      createNewTagValue: '__create_new_tag__',
      showAddressSearchModal: false,
      showAddressValidationSidebar: false,
      addressValidationResult: null,
      validatingAddress: false,
      selectedCandidateId: null,
      confirmingCorrection: false,
      showMoveStorefrontSidebar: false,
      moveToStorefrontForm: {
        storefrontId: '',
        orderGroupId: '',
        reason: '',
        ignoreShopify: false
      },
      movingToStorefront: false,
      itemsNotStockedCannotMove: false,
      itemsNotStockedErrorMessage: '',
      showFulfillOverlay: false,
      onHoldReasonOptions: [
        { value: 'Manual Hold', text: 'Manual Hold' },
        { value: 'Not Enough Inventory', text: 'Not Enough Inventory' },
        { value: 'Review Needed Because Undid Pending', text: 'Review Needed Because Undid Pending' }
      ],
      orderChangeItemForm: {
        unitPrice: 0,
        unitWeightOz: 0,
        sku: '',
        name: '',
        productId: null,
        quantity: 1
      },
      orderItemFields: [
        { key: 'sku', label: 'SKU', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'quantity', label: 'Quantity', sortable: false },
        { key: 'unitPrice', label: 'Price', sortable: false },
        { key: 'unitWeightOz', label: 'Weight', sortable: false },
        { key: 'actions' }
      ],

      loadingPage: false,
      fieldsItems: [
        { key: 'sku', label: 'Sku', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'quantity', label: 'Quantity', sortable: false },
        //{ key: 'fulfillmentSku', label: 'Fulfillment Sku', sortable: false },
        { key: 'unitPrice', label: 'Unit Price', sortable: false }
      ],
      shipmentFields: [
        {
          key: 'fulfilledByService',
          label: 'Fulfilled By',
          sortable: false
        },
        { key: 'trackingNumber', label: 'Tracking Number', sortable: false },
        //{ key: 'externalShipmentId', label: 'External ID', sortable: false },
        { key: 'carrierCode', label: 'Carrier', sortable: false },
        { key: 'dimensions', label: 'Dimensions', sortable: false },
        { key: 'weight', label: 'Weight', sortable: false },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'receiveDate', label: 'Delivered On', sortable: false },
        { key: 'id', label: 'Actions', sortable: false }
      ],
      shipmentItemsFields: [
        { key: 'sku', label: 'Sku', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'quantity', label: 'Quantity', sortable: false },
        { key: 'fullfillInfo', label: 'Fulfillment Info', sortable: false },
      ],
      //toPickOrderItems: [],
      toPickProducts: [],
      reshipItemsPicked: [],
      reshipItemForm: {
        productItm: null,
        quantity: 1,
        unitPrice: 0
      },
      showReshipForm: false,
      showSplitForm: false,
      splitOrderInf: null,
      loadingOrderChange: false,
      markingDeliveredShipmentId: null,
      editingOrder: false,
      resolvedItems: [],
      orderItemInventory: [],
      baseOrder: {
        orderDate: '',
        paymentDate: '',
        shipByDate: ''
      },
      originalOrder: null,
      reshipReason: 'Wrong Product Received',
      doFullReship: true,
      toReshipOrder: false,
      activeShipment: false,
      shipmentItems: false,
      showShipmentItemsModal: false,
      reshipReasonsList: [
        {
          value: 'Wrong Product Received',
          text: 'Wrong Product Received',
          sortable: false
        },
        {
          value: 'Damaged Product by Carrier',
          text: 'Damaged Product by Carrier',
          sortable: false
        },
        {
          value: 'Missing Packets in Box',
          text: 'Missing Packets in Box',
          sortable: false
        },
        {
          value: 'Missing Item from Order',
          text: 'Missing Item from Order',
          sortable: false
        },
        {
          value: 'Damaged Product in Box',
          text: 'Damaged Product in Box',
          sortable: false
        },
        {
          value: 'Returned To Sender',
          text: 'Returned To Sender',
          sortable: false
        },
        {
          value: 'Empty Packets in Box',
          text: 'Empty Packets in Box',
          sortable: false
        },
        {
          value: 'Package Lost in Transit',
          text: 'Package Lost in Transit',
          sortable: false
        },
        {
          value: 'Exchange',
          text: 'Exchange',
          sortable: false
        },
        {
          value: 'Other',
          text: 'Other',
          sortable: false
        }
      ],
      order: {
        orderDate: '',
        paymentDate: '',
        shipByDate: ''
      },
      tagsAll: [],
      // Optimal packaging box data
      optimalBoxResult: null,
      loadingOptimalBox: false,
      optimalBoxError: null,
      optimalBoxItemsExpanded: {}, // Track expanded state for each box
      // Order returns data
      orderReturns: [],
      loadingOrderReturns: false,
      orderReturnsError: null
    };
  },
  computed: {
    canEditOnHoldReason() {
      const editableReasons = ['Manual Hold', 'Not Enough Inventory', 'Review Needed Because Undid Pending'];
      return this.order && this.order.onHoldReason && editableReasons.includes(this.order.onHoldReason);
    },
    availableTagOptions() {
      if (!this.order) {
        return [];
      }
      return this.tagsAll
        .filter(t => t.projectId == this.order.projectId && !this.editTagsForm.tagIds.includes(t.tagId))
        .map(t => ({ value: t.tagId, text: t.name }));
    },
    addTagOptions() {
      return this.availableTagOptions.concat([
        { value: this.createNewTagValue, text: '➕ Create New Tag' }
      ]);
    },
    isCreatingNewTag() {
      return this.editTagsAddSelected === this.createNewTagValue;
    },
    canAddTag() {
      if (this.isCreatingNewTag) {
        return !!(this.editTagsNewName && this.editTagsNewName.trim());
      }
      return !!this.editTagsAddSelected;
    },
    productsList: {
      get() {
        let arrs = [];
        this.storeProdsList.forEach(itm => {
          arrs.push({
            value: itm.id,
            text: itm.sku + ' (' + itm.name + ')'
          });
        });
        return arrs;
      },
      set(old, val) {}
    },
    itemsTotal: {
      get() {
        let total = 0;
        if (this.order && this.order.items) {
          let items = this.order.items;
            items.forEach(itm => {
            let totalPrice = parseFloat(itm.unitPrice * itm.quantity);
            total += totalPrice;
          });
        }
        return total;
      },
      set(val, old) {
        // this.productListAll = val;
      }
    },
    // toPickProductsList: {
    //   get() {
    //     let list = this.toPickProducts;
    //     let arrs = [];
    //     list.forEach(itm => {
    //       arrs.push({
    //         label: itm.name + ' (' + itm.sku + ')',
    //         value: itm.productId
    //       });
    //     });
    //     return arrs;
    //   },
    //   set(val, old) {
    //     // this.productListAll = val;
    //   }
    // },
    ssAssignedOfOrder: {
      get() {
        let assignedTo = null;
        if (this.order && this.order.projectId && this.order.userId && this.shipStationUsers&& this.shipStationUsers.length) {
          assignedTo = this.shipStationUsers.find(a => a.userId == this.order.userId);
        }
        return assignedTo == null ? '' : (assignedTo.name + ' ('+assignedTo.userName+')');
      },
      set(val, old) {
        // this.productListAll = val;
      }
    },
    orderStorefront: {
      get() {
        let project = null;
        if (this.order && this.order.projectId) {
          project = this.myProjects.find(a => a.id == this.order.projectId);
          if(project && project.onlyFulfillShipStationUserId && this.order.sourcedFrom == 'ShipStation') {
            this.loadShipStationUsers(this.order.projectId);
          }
        }
        return project == null ? '' : project;
      },
      set(val, old) {
        // this.productListAll = val;
      }
    },
    // The full project object of the order (projectOfOrder is only its name).
    activeProject() {
      if (this.order && this.order.projectId) {
        return this.myProjects.find(a => a.id == this.order.projectId) || null;
      }
      return null;
    },
    // Weights are only editable / relevant when the storefront sends them.
    orderItemFieldsVisible() {
      if (this.activeProject && !this.activeProject.sendWeightsFromStorefront) {
        return this.orderItemFields.filter(a => a.key != 'unitWeightOz');
      }
      return this.orderItemFields;
    },
    projectOfOrder: {
      get() {
        let project = null;
        if (this.order && this.order.projectId) {
          project = this.myProjects.find(a => a.id == this.order.projectId);
        }
        return project == null ? '' : project.name;
      },
      set(val, old) {
        // this.productListAll = val;
      }
    },
    storeOfOrder: {
      get() {
        let store = null;
        if (this.order && this.order.storeId) {
          store = this.myStores.find(a => a.id == this.order.storeId);
        }
        return store == null ? '' : store.storeName;
      },
      set(val, old) {
        // this.productListAll = val;
      }
    },
    moveToStorefrontOptions() {
      if (!this.orderStorefront || !this.orderStorefront.brandId) return [];
      const brandId = this.orderStorefront.brandId;
      const currentProjectId = this.order ? this.order.projectId : null;
      return this.myProjects
        .filter(p => p.brandId === brandId && p.id !== currentProjectId)
        .map(p => ({ value: p.id, text: p.name }));
    },
    moveToOrderGroupOptions() {
      if (!this.moveToStorefrontForm.storefrontId) return [];
      return this.myStores
        .filter(s => s.projectId === this.moveToStorefrontForm.storefrontId)
        .map(s => ({ value: s.id, text: s.storeName }));
    },
    // projectsList: {
    //   get() {
    //     let arrs = [];
    //     this.projectAll.forEach(itm => {
    //       arrs.push({
    //         value: itm.id,
    //         text: itm.name + ' (' + itm.clientCode + ')'
    //       });
    //     });
    //     return arrs;
    //   },
    //   set(old, val) {}
    // }
  },
  watch: {
    'orderChangeItemForm.pickedProduct': function(newVal) {
      var prod = this.storeProdsList.find(a => a.id == newVal);
      if (prod) {
        this.orderChangeItemForm.productId = prod.productId;
        this.orderChangeItemForm.unitPrice = prod.price;
        this.orderChangeItemForm.unitWeightOz = parseFloat(prod.weightOz);
        if(!prod.weightOz) {
          this.orderChangeItemForm.unitWeightOz = 0;
        } else {
          this.orderChangeItemForm.unitWeightOz = parseFloat(prod.weightOz);
        }
        this.orderChangeItemForm.addProductSku = prod.sku;
      } else {
        this.orderChangeItemForm.addProductSku = newVal;
        this.orderChangeItemForm.productId = '';
        this.orderChangeItemForm.unitPrice = 0;
        this.orderChangeItemForm.unitWeightOz = 0;
      }
    },
    'orderChangeItemForm.productId': function(newVal) {
      var prod = this.storeProdsList.find(a => a.productId == newVal);
      if (prod) {
        this.orderChangeItemForm.unitPrice = prod.price;
        this.orderChangeItemForm.unitWeightOz = prod.weightOz
      }
    },
    'order.orderNumber': function(val) {
      // if(this.order.orderKey != val) {
      //   this.order.orderKey = val;
      // }
    },
    '$route.query.id': function(val) {
      this.id = val;
      this.order = {
        orderDate: '',
        paymentDate: '',
        shipByDate: ''
      };
      this.loadItem();
    },
    order: {
      handler: function(newOrder) {
        if (newOrder && newOrder.id) {
          this.fetchOrderReturns();
        }
      },
      deep: true
    },
    pagination: {
      handler: function(val, oldVal) {
        this.loadItem();
      },
      deep: true
    },
    showReshipForm: function(val) {
      if (!val) {
        this.doFullReship = true;
        this.reshipItemForm = {
          productItm: null,
          quantity: 1,
          unitPrice: 0
        };
        this.toPickProducts = [];
        this.reshipItemsPicked = [];
      }
    },
    'reshipItemForm.productItm': function(picked) {
      if(picked) {
        let productId = picked.value;
        if (productId) {
          //this.ProductPicked(productId);
        }
      }
    }
  },
  meta() {
    let titl = (this.order && this.order.orderNumber) ? ('Order #' + this.order.orderNumber) : 'Order Details';
      return {
          title: titl,
          // ...
      };
  },
  mounted() {
    this.editingOrder = false;
    let queryHas = this.$route.query;
    if (queryHas && queryHas.id) {
      this.id = queryHas.id;
    }
    this.loadItem();
    try {
      this.$userHub.$on('order-updated', (payload) => {
        this.loadItem();
      });
      this.$userHub.$emit('JoinRoom', 'Order-'+this.id)
    } catch {
      console.log('error order')
    }
  },
  beforeDestroy: function() {
    try {
      this.$userHub.$emit('LeaveRoom', 'Order-'+this.id)
    } catch {
      console.log('error order')
    }
  },
  methods: {
    currencySymbol(currency) {
      if (!currency || currency === 'USD') return '$';
      switch (currency.toUpperCase()) {
        case 'EUR': return 'EUR €';
        case 'GBP': return 'GBP £';
        case 'CAD': return 'CA$';
        case 'AUD': return 'A$ ';
        case 'SEK': return 'kr ';
        case 'NOK': return 'kr ';
        case 'DKK': return 'kr ';
        case 'MXN': return 'MX$ ';
        case 'BRL': return 'R$ ';
        case 'INR': return '₹ ';
        case 'KRW': return '₩ ';
        case 'SGD': return 'S$ ';
        case 'HKD': return 'HK$ ';
        case 'NZD': return 'NZ$ ';
        case 'PLN': return 'zł ';
        case 'CZK': return 'Kč ';
        case 'HUF': return 'Ft ';
        case 'RON': return 'lei ';
        default: return currency +' ';
      }
    },
    openAddressSearchModal() {
      this.showAddressSearchModal = true;
    },
    onAddressSearchConfirmed(result) {
      this.order.shipTo.street1 = result.street1;
      this.order.shipTo.street2 = result.street2;
      this.order.shipTo.city = result.city;
      this.order.shipTo.state = result.state;
      this.order.shipTo.postalCode = result.postalCode;
      this.order.shipTo.country = result.country;
    },
    RequestNewReturn() {
      this.$http.post('/api/common/storefront-orders/request-return', {
        orderId: this.order.id,
        warehouseId: this.orderStorefront.warehouseId
      })
      .then(response => {
        if (response.data && response.data.isSuccess) {
            this.$swal('Success!', 'Order return was entered, label generated.', 'success');
        }
        else 
        {
          this.$swal('Error', 'Something went wrong, could not generate return request!', 'error');
        }
        this.fetchOrderReturns();
      })
      .catch(error => {
        this.$swal('Error', error.response.data.errorMessage, 'error');
      })
      .finally(() => {
      });
    },
    openEditOnHoldReasonModal() {
      this.selectedOnHoldReason = this.order.onHoldReason;
      this.showEditOnHoldReasonModal = true;
    },
    updateOnHoldReason() {
      this.updatingOnHoldReason = true;
      
      this.$http.put('/api/common/storefront-orders/edit-onhold-reason', {
        orderId: this.order.id,
        onHoldReason: this.selectedOnHoldReason
      })
        .then(response => {
          if (response.data && response.data.message) {
            this.$swal('Success!', response.data.message, 'success');
            this.order.onHoldReason = this.selectedOnHoldReason;
            this.showEditOnHoldReasonModal = false;
          }
        })
        .catch(error => {
            this.$swal({ title: 'Failed!', text: error.response.data.errorMessage, icon: 'error' });
        })
        .finally(() => {
          this.updatingOnHoldReason = false;
        });
    },
    openMoveStorefrontSidebar() {
      this.moveToStorefrontForm = { storefrontId: '', orderGroupId: '', reason: '', ignoreShopify: false };
      this.itemsNotStockedCannotMove = false;
      this.itemsNotStockedErrorMessage = '';
      this.showMoveStorefrontSidebar = true;
    },
    submitMoveToStorefront(hide) {
      this.movingToStorefront = true;
      this.$http.post('/api/common/storefront-orders/move-to-storefront', {
        orderId: this.order.id,
        moveToStorefrontId: this.moveToStorefrontForm.storefrontId,
        moveToOrderGroupId: this.moveToStorefrontForm.orderGroupId,
        reason: this.moveToStorefrontForm.reason || null,
        ignoreShopify: this.moveToStorefrontForm.ignoreShopify
      })
        .then(response => {
          if (response.data && response.data.message) {
            this.$swal('Success!', response.data.message, 'success');
            hide();
            this.loadItem();
          }
        })
        .catch(error => {
          var errorCode = error.response && error.response.data && error.response.data.errorCode;
          var errorMessage = error.response && error.response.data && error.response.data.errorMessage;
          if (errorCode === 'ItemsNotStocked') {
            this.itemsNotStockedCannotMove = true;
            this.itemsNotStockedErrorMessage = errorMessage || 'Items are not stocked at the target location.';
          } else if (errorMessage) {
            this.$swal({ title: 'Failed!', text: errorMessage, icon: 'error' });
          } else {
            this.$swal({ title: 'Something went wrong!', icon: 'error' });
          }
        })
        .finally(() => {
          this.movingToStorefront = false;
        });
    },
    CopyToClipboard(cipId) {
      const element = this.$refs[cipId][0].$el;
      element.select();
      element.setSelectionRange(0, 99999);
      window.document.execCommand('copy');
      this.$bvToast.toast(
          'URL for Checkout was copied to your clipboard!',
          {
            title: 'URL Copied!',
            variant: 'secondary',
            autoHideDelay: 1100
          }
        );
    },
    loadShipStationUsers(projectId) {
      this.$http
        .get('/api/common/manage/storefronts/listShipStationUsers/'+projectId)
        .then(resp => {
          if(resp.data.length) {
            this.shipStationUsers = resp.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    AddOrderItem() {
        if (
          (this.orderChangeItemForm.productId || this.orderChangeItemForm.addProductSku) &&
          parseFloat(this.orderChangeItemForm.quantity) > 0
        ) {
          if(this.orderChangeItemForm.productId) {
            let prod = this.storeProdsList.find(
              a => a.productId == this.orderChangeItemForm.productId
            );
            this.itemForm.items.push({
              orderId: this.itemForm.id,
              newItemToAdd: true,
              sku: prod.sku,
              name: prod.name,
              quantity: parseInt(this.orderChangeItemForm.quantity),
              unitPrice: parseFloat(this.orderChangeItemForm.unitPrice),
              weight: {
                value: parseFloat(this.orderChangeItemForm.unitWeightOz),
                units: 'ounces'
              },
              unitWeightOz: parseFloat(this.orderChangeItemForm.unitWeightOz),
              productId: this.orderChangeItemForm.productId
            });
          } else if(this.orderChangeItemForm.addProductSku){
            let prod = this.storeProdsList.find(
              a => a.id == this.orderChangeItemForm.addProductSku
            );
            let prod2 = this.storeProdsList.find(
              a => a.sku == this.orderChangeItemForm.addProductSku
            );
            if(prod) {
              this.itemForm.items.push({
                orderId: this.itemForm.id,
                orderItemId: 'itm' + new Date().getUTCMilliseconds(),
                newItemToAdd: true,
                sku: prod.sku,
                name: prod.name,
                quantity: parseInt(this.orderChangeItemForm.quantity),
                unitPrice: parseFloat(this.orderChangeItemForm.unitPrice),
                weight: {
                  value: parseFloat(this.orderChangeItemForm.unitWeightOz),
                  units: 'ounces'
                },
                unitWeightOz: parseFloat(this.orderChangeItemForm.unitWeightOz),
                productId: prod.productId
              });
            } else if(prod2) {
              this.itemForm.items.push({
                orderId: this.itemForm.id,
                orderItemId: 'itm' + new Date().getUTCMilliseconds(),
                newItemToAdd: true,
                sku: prod2.sku,
                name: prod2.name,
                quantity: parseInt(this.orderChangeItemForm.quantity),
                unitPrice: parseFloat(this.orderChangeItemForm.unitPrice),
                weight: {
                  value: parseFloat(this.orderChangeItemForm.unitWeightOz),
                  units: 'ounces'
                },
                unitWeightOz: parseFloat(this.orderChangeItemForm.unitWeightOz),
                productId: prod2.productId
              });
            } else {
              this.itemForm.items.push({
                orderId: this.itemForm.id,
                orderItemId: 'itm' + new Date().getUTCMilliseconds(),
                newItemToAdd: true,
                sku: this.orderChangeItemForm.addProductSku,
                name: this.orderChangeItemForm.addProductSku,
                quantity: parseInt(this.orderChangeItemForm.quantity),
                unitPrice: parseFloat(this.orderChangeItemForm.unitPrice),
                weight: {
                  value: parseFloat(this.orderChangeItemForm.unitWeightOz),
                  units: 'ounces'
                },
                unitWeightOz: parseFloat(this.orderChangeItemForm.unitWeightOz),
                productId: ''
              });
            }
          }
          this.orderChangeItemForm = {
            unitPrice: 0,
            unitWeightOz: 0,
            addProductSku: '',
            sku: '',
            name: '',
            productId: null,
            quantity: 1
          };
        }
    },

    RemoveItem(item) {
      this.itemForm.items = this.itemForm.items.filter(
        a => a.id != item.id
      );
    },

    RemoveItem2(item) {
      this.itemForm.items = this.itemForm.items.filter(
        a => a.sku != item.sku
      );
    },
    LoadProductsFor(projectId) {
      this.storeProdsList = [];
      if (projectId) {
        this.loadingProductItems = true;
        this.storeProdsList = [];
        this.$http
          .post('/api/common/products/byProject/' + projectId)
          .then(resp => {
            this.storeProdsList = resp.data;
            this.loadingProductItems = false;
          })
          .catch(err => {
            this.storeProdsList = [];
            this.loadingProductItems = false;
          });
      }
    },
    SplitShipmentOrder(order) {
      this.splitOrderInf = order;
      this.showSplitForm = true;
    },
    OpenCreateMappingPage() {
      this.$router.push({
        name: 'Storefronts.ShipCodeMappings.Create',
        query: { fulfillmentService: (this.orderStorefront ? this.orderStorefront.fulfillmentService : ''),  projectId: this.order.projectId, requestedService: this.order.requestedShippingService, orderCarrierCode: (this.order.carrierCode ? this.order.carrierCode : ''), orderServiceCode: (this.order.serviceCode ? this.order.serviceCode : '') }
      });
    },
    getImageUrlFor(shipItem) {
      let imageUrl = '';
      let fndOrderItem = this.order.items.find(
        a => a.itemId == shipItem.itemId
      );
      if (fndOrderItem) {
        imageUrl = fndOrderItem.imageUrl;
      }
      return imageUrl;
    },
    getTagById(projId, id) {
      let tagResp = '';
      let tagItem = false;
      tagItem = this.tagsAll.find(s => s.projectId == projId && s.tagId == id);
      if (tagItem) {
        tagResp = `<span class="badge badge-primary" style="background-color: ${tagItem.color}">${tagItem.name}</span> `;
      }
      return tagResp;
    },
    openEditTagsModal() {
      this.editTagsForm = {
        tagIds: (this.order.orderTagIds ? this.order.orderTagIds.slice() : []),
        newTags: []
      };
      this.editTagsAddSelected = '';
      this.editTagsNewName = '';
      this.editTagsNewColor = '#6c757d';
      this.showEditTagsModal = true;
    },
    tagNameById(id) {
      let t = this.tagsAll.find(s => s.tagId == id);
      return t ? t.name : id;
    },
    tagColorById(id) {
      let t = this.tagsAll.find(s => s.tagId == id);
      return t && t.color ? t.color : '#6c757d';
    },
    addSelectedTag() {
      if (this.isCreatingNewTag) {
        this.addNewTag();
      } else {
        this.addExistingTag();
      }
    },
    addExistingTag() {
      if (this.editTagsAddSelected && !this.editTagsForm.tagIds.includes(this.editTagsAddSelected)) {
        this.editTagsForm.tagIds.push(this.editTagsAddSelected);
      }
      this.editTagsAddSelected = '';
    },
    removeTagFromForm(id) {
      this.editTagsForm.tagIds = this.editTagsForm.tagIds.filter(t => t != id);
    },
    addNewTag() {
      if (this.editTagsNewName && this.editTagsNewName.trim()) {
        this.editTagsForm.newTags.push({
          name: this.editTagsNewName.trim(),
          color: this.editTagsNewColor
        });
        this.editTagsNewName = '';
        this.editTagsNewColor = '#6c757d';
        this.editTagsAddSelected = '';
      }
    },
    removeNewTag(idx) {
      this.editTagsForm.newTags.splice(idx, 1);
    },
    // Deterministically derive a color from the tag name (same hashing approach as
    // palletColorGen elsewhere, with valid #rrggbb output for the color input).
    palletColorGen(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      let colour = '#';
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).slice(-2);
      }
      return colour;
    },
    saveTags() {
      this.savingTags = true;
      this.$http.put('/api/common/storefront-orders/edit-tags', {
        orderId: this.order.id,
        tagIds: this.editTagsForm.tagIds,
        newTags: this.editTagsForm.newTags
      })
        .then(response => {
          if (response.data && response.data.message) {
            this.$swal('Success!', response.data.message, 'success');
            this.showEditTagsModal = false;
            this.loadItem();
          }
        })
        .catch(error => {
          this.$swal({
            title: 'Failed!',
            text: (error.response && error.response.data && error.response.data.errorMessage) || 'Something went wrong while updating tags',
            icon: 'error'
          });
        })
        .finally(() => {
          this.savingTags = false;
        });
    },
    loadTags() {
      this.$http
        .post('/api/common/orderTags/byProjectId/'+this.order.projectId,
        {})
        .then(resp => {
          this.tagsAll = resp.data;
        })
        .catch(err => {});
    },

    OrderReshipConfirm(order) {
      this.$router.push({
        name: 'apps-customer-orders-create',
        query: { reshipOrderId: this.order.id, reshippedReason: this.reshipReason }
      });
    },
    StartEditingOrder() {
      this.originalOrder = JSON.parse(JSON.stringify(this.order));
      this.editingOrder = true;
      let ordr = this.order;
      ordr.items.forEach((itm)=> {
        if(itm.weight) {
          if(itm.weight.units == 'ounces') {
              itm.unitWeightOz = itm.weight.value;
          } else if(itm.weight.units == 'grams') {
              itm.unitWeightOz = parseFloat( parseFloat(parseFloat(itm.weight.value) / 28.34952).toFixed(2) );
          }
        } else {
            itm.unitWeightOz = 0;
        }
      })
      this.itemForm = ordr;
      this.LoadProductsFor(this.order.projectId);
    },
    CancelEditingOrder() {
      this.originalOrder = null;
      this.editingOrder = false;
    },
    SimulateSunbasketOrder() {
      let order = this.order;
      this.loadingOrderChange = true;
      let swl = this.$swal({
        title: 'Validating Order!',
        text: 'Please wait...',
        icon: 'warning',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
      this.$http
        .post('/api/common/orders/' + order.id + '/sunbasket-simulate', order)
        .then(resp => {
          this.loadingOrderChange = false;
          //this.editingOrder = false;
          swl.close();
          if(resp.data.success) {
            this.$swal('Success!', 'Order was validated against Sunbasket. No issues detected.', 'success');
            this.loadItem();
          } else {
            this.$swal('Success!', 'Something went wrong', 'error');
          }
        })
        .catch(err => {
          this.loadingOrderChange = false;
            swl.close();
            console.error(err);
            if (err.response && err.response.data.errorMessage) {
              this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
            } else {
              this.$swal({ title: 'Something went wrong!', icon: 'error' });
            }
        });
    },
    EditOrder() {
      let order = this.order;
      this.$swal({
        title: 'Are you sure you want to save these changes?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Save Order'
      }).then(result => {
        if (result.value) {
          let swl = this.$swal({
            title: 'Updating Order!',
            text: 'Please wait...',
            icon: 'warning',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
          });
          this.loadingOrderChange = true;
          this.$http
            .post('/api/common/orders/' + order.id + '/edit', order)
            .then(resp => {
              this.loadingOrderChange = false;
              this.editingOrder = false;
              swl.close();
              if(resp.data.success) {
                this.$swal('Success!', 'Order was changed.', 'success');
                order.orderStatus = 'on_hold';
                this.loadItem();
              } else {
                this.$swal('Success!', 'Something went wrong', 'error');
              }
            })
            .catch(err => {
                this.loadingOrderChange = false;
                swl.close();
                console.error(err);
                  if (err.response && err.response.data.errorMessage) {
                    this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
                  } else {
                    this.$swal({ title: 'Something went wrong!', icon: 'error' });
                  }
            });
        } else {
          this.order = this.originalOrder;
          this.editingOrder = false;
        }
      });
    },
    ReProcessOrder(order, warnIfAlloc = true) {
      let txt2 = 'Are you REALLY sure you want to do that?';
      let msgWArning = "This will remove the pending fulfillment status by placing the storefront order on hold, and cancelling the order in the warehouse!";
      if(order.fulfilledByService == 'Crane') {
        msgWArning = "This will remove the pending fulfillment status by placing the storefront order on hold! NOTE: This will NOT cancel the order at Crane! Make sure the order is already cancelled at Crane before using this!";
        txt2 = 'You sure you CANCELLED in Crane?';
      }
      if(!warnIfAlloc) {
        txt2 = 'Already allocated, remember! Are you REALLY sure?';
        msgWArning = "Order was already allocated and is being packed by someone at the warehouse, if you continue, the order will be unallocated and any pick ticket invalidated! You might need to contact someone at the floor to stop packing if you haven't already.";
      }
      this.$swal({
        title: 'Are you sure?',
        text: msgWArning,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Do it.'
      }).then(result => {
        if (result.value) {
            this.$swal({
              title: txt2,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, do it!'
            }).then(result => {
              if (result.value) {
                let swl = this.$swal({
                  title: 'Updating Order!',
                  text: 'Please wait...',
                  icon: 'warning',
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false
                });
                this.loadingOrderChange = true;
                this.$http
                  .post('/api/common/orders/' + order.id + '/reprocess', {
                    warnIfAllocated: warnIfAlloc
                  })
                  .then(resp => {
                    this.loadingOrderChange = false;
                    swl.close();
                    if(resp.data.success) {
                      this.$swal('Success!', 'Order was placed into on hold. When ready, remove from hold, and it will be resent to the fulfillment service!', 'success');
                      order.orderStatus = 'on_hold';
                      this.loadItem();
                    } else {
                      this.$swal('Success!', 'Something went wrong', 'error');
                    }
                  })
                  .catch(err => {
                      this.loadingOrderChange = false;
                      swl.close();
                      console.error(err);
                      if (err.response && err.response.data.errorMessage) {
                        if(err.response.data.errorMessage == 'This order is already being packed! Are you sure?') {
                          this.ReProcessOrder(order, false);
                        } else {
                          this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
                        }
                      } else {
                        this.$swal({ title: 'Something went wrong!', icon: 'error' });
                      }
                  });
              }
            });
        }
      });
    },
    MarkShippedOrder(order) {
      this.$swal({
        title: 'Are you sure you want to mark this order shipped?',
        text: 'You won\'t be able to undo this.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Do it.'
      }).then(result => {
        if (result.value) {
            this.$swal({
              title: 'Are you REALLY sure?',
              text: 'You can enter a tracking number, or leave it empty if you do not have one.',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Mark Shipped!',
              input: 'text',
              inputLabel: 'Tracking Number',
              inputPlaceholder: 'Enter the tracking number',
              inputAttributes: {
                maxlength: 30,
                autocapitalize: 'off',
                autocorrect: 'off'
              }
            }).then(result => {
              //if (result.value) {
                let trackingNumber = result.value;
                let swl = this.$swal({
                  title: 'Updating Order!',
                  text: 'Please wait...',
                  icon: 'warning',
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false
                });
                this.loadingOrderChange = true;
                this.$http
                  .post('/api/common/orders/' + order.id + '/markShipped', {
                    trackingNumber: trackingNumber
                  })
                  .then(resp => {
                    this.loadingOrderChange = false;
                    swl.close();
                    if(resp.data.success) {
                      this.$swal('Success!', 'Order was marked shipped.', 'success');
                      order.orderStatus = 'shipped';
                      this.loadItem();
                    } else {
                      this.$swal('Success!', 'Something went wrong', 'error');
                    }
                  })
                  .catch(err => {
                      this.loadingOrderChange = false;
                      swl.close();
                      console.error(err);
                      if (err.response && err.response.data.errorMessage) {
                        this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
                      } else {
                        this.$swal({ title: 'Something went wrong!', icon: 'error' });
                      }
                  });
              //}
            });
        }
      });
    },
    AwaitShipOrder(order) {
      this.$swal({
        title: 'Are you sure you want to place this order into awaiting shipment?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Do it.'
      }).then(result => {
        if (result.value) {
            this.$swal({
              title: 'Are you REALLY sure you want to do that?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, do it!'
            }).then(result => {
              if (result.value) {
                let swl = this.$swal({
                  title: 'Updating Order!',
                  text: 'Please wait...',
                  icon: 'warning',
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false
                });
                this.loadingOrderChange = true;
                this.$http
                  .post('/api/common/orders/' + order.id + '/awaitShip')
                  .then(resp => {
                    this.loadingOrderChange = false;
                    swl.close();
                    if(resp.data.success) {
                      this.$swal('Success!', 'Order was placed into awaiting shipment.', 'success');
                      order.orderStatus = 'on_hold';
                      this.loadItem();
                    } else {
                      this.$swal('Success!', 'Something went wrong', 'error');
                    }
                  })
                  .catch(err => {
                      this.loadingOrderChange = false;
                      swl.close();
                      console.error(err);
                      if (err.response && err.response.data.errorMessage) {
                        this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
                      } else {
                        this.$swal({ title: 'Something went wrong!', icon: 'error' });
                      }
                  });
              }
            });
        }
      });
    },
    CancelOrder(order) {
      let txt2 = 'Are you REALLY sure you want to do that?';
      let msgWArning = "This will cancel the order in the storefront as well!";
      if(order.fulfilledByService == 'Crane') {
        msgWArning = "This will cancel the order in the storefront as well! NOTE: This will NOT cancel the order at Crane! Make sure the order is already cancelled at Crane before using this!";
        txt2 = 'You sure you CANCELLED in Crane?';
      }
      this.$swal({
        title: 'Are you sure you want to cancel this order?',
        text: msgWArning,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Cancel it.'
      }).then(result => {
        if (result.value) {
            this.$swal({
              title: 'Are you REALLY sure you want to cancel?',
              text: txt2,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, cancel it!'
            }).then(result => {
              if (result.value) {
                let swl = this.$swal({
                  title: 'Updating Order!',
                  text: 'Please wait...',
                  icon: 'warning',
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false
                });
                this.loadingOrderChange = true;
                this.$http
                  .post('/api/common/orders/' + order.id + '/cancel')
                  .then(resp => {
                    this.loadingOrderChange = false;
                    swl.close();
                    if(resp.data.success) {
                      this.$swal('Success!', 'Order was cancelled.', 'success');
                      order.orderStatus = 'on_hold';
                      this.loadItem();
                    } else {
                      this.$swal('Success!', 'Something went wrong', 'error');
                    }
                  })
                  .catch(err => {
                      this.loadingOrderChange = false;
                      swl.close();
                      console.error(err);
                      if (err.response && err.response.data.errorMessage) {
                        this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
                      } else {
                        this.$swal({ title: 'Something went wrong!', icon: 'error' });
                      }
                  });
              }
            });
        }
      });
    },
    ReleaseHold(order) {
      let swl = this.$swal({
        title: 'Updating Order!',
        text: 'Please wait...',
        icon: 'warning',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
      this.loadingOrderChange = true;
      this.$http
        .delete('/api/common/orders/' + order.id + '/hold')
        .then(resp => {
          this.loadingOrderChange = false;
          swl.close();
          if(resp.data.success) {
            this.$swal('Success!', 'Order was released.', 'success');
            order.orderStatus = 'awaiting_shipment';
            this.loadItem();
          } else {
            this.$swal('Error!', 'Something went wrong', 'error');
          }
        })
        .catch(err => {
          this.loadingOrderChange = false;
          swl.close();
          console.error(err);
          if (err.response && err.response.data.errorMessage) {
            this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
          } else {
            this.$swal({ title: 'Something went wrong!', icon: 'error' });
          }
        });
    },
    PutOnHold(order) {
      let swl = this.$swal({
        title: 'Updating Order!',
        text: 'Please wait...',
        icon: 'warning',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
      this.loadingOrderChange = true;
      this.$http
        .post('/api/common/orders/' + order.id + '/hold')
        .then(resp => {
          this.loadingOrderChange = false;
          swl.close();
          if(resp.data.success) {
            this.$swal('Success!', 'Order was put on hold.', 'success');
            order.orderStatus = 'on_hold';
            this.loadItem();
          } else {
            this.$swal('Success!', 'Something went wrong', 'error');
          }
        })
        .catch(err => {
            this.loadingOrderChange = false;
            swl.close();
            console.error(err);
            if (err.response && err.response.data.errorMessage) {
              this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
            } else {
              this.$swal({ title: 'Something went wrong!', icon: 'error' });
            }
        });
    },
    RetryVirtualFulfillOrder(order) {
      let swl = this.$swal({
        title: 'Updating Order!',
        text: 'Please wait...',
        icon: 'warning',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
      this.loadingOrderChange = true;
      this.$http
        .post('/api/common/orders/' + order.id + '/virtualRetry')
        .then(resp => {
          this.loadingOrderChange = false;
          swl.close();
          if(resp.data.success) {
            this.$swal('Success!', 'Order is queued for getting mirrored to warehouse.', 'success');
            order.orderStatus = 'on_hold';
            this.loadItem();
          } else {
            this.$swal('Success!', 'Something went wrong', 'error');
          }
        })
        .catch(err => {
            this.loadingOrderChange = false;
            swl.close();
            console.error(err);
            if (err.response && err.response.data.errorMessage) {
              this.$swal({ title: 'Failed!', text: err.response.data.errorMessage, icon: 'error' });
            } else {
              this.$swal({ title: 'Something went wrong!', icon: 'error' });
            }
        });
    },
    OrderReship(order) {
      this.reshipItemForm.productId = '';
      this.reshipItemForm.unitPrice = 0;
      this.reshipItemForm.quantity = 1;
      this.toPickProducts = [];

      this.$http
        .post('/api/common/products/byProject/' + order.projectId)
        .then(resp => {
          this.toReshipOrder = order;
          this.reshipItemsPicked = order.items;
          this.toPickProducts = resp.data;
          this.showReshipForm = true;
        })
        .catch(err => {});
    },

    loadItem() {
      this.$http
        .get('/api/common/orders/' + this.id)
        .then(resp => {
          this.editingOrder = false;
          this.baseOrder = JSON.parse(JSON.stringify(resp.data));
          let ordr = resp.data;
          if(ordr.items) {
            ordr.items.forEach((it) => {
              if(it.adjustment) {
              it['_rowVariant'] = 'danger';
              }
            })
          }
          this.order = ordr;
          this.chatWidgetProps.relatedName = 'Storefront Order: ' + this.order.orderNumber;
          this.chatWidgetProps.relatedId = this.order.id;

          this.loadTags();
          this.loadResolvedItems();
        })
        .catch(err => {
          console.error(err);
        });
      this.loadingPage = true;
    },
    loadResolvedItems() {
      this.resolvedItems = [];
      this.$http.get('/api/common/storefront-orders/' + this.id + '/resolved-items')
        .then(resp => {
          this.resolvedItems = (resp.data && resp.data.items) || [];
          this.orderItemInventory = (resp.data && resp.data.orderItemInventory) || [];
        })
        .catch(() => {
          // Bundle and inventory info is informational only, the order page works without it.
          this.resolvedItems = [];
          this.orderItemInventory = [];
        });
    },
    getItemInventory(orderItemId) {
      return this.orderItemInventory.find(a => a.orderItemId == orderItemId) || null;
    },
    getBundleComponents(orderItemId) {
      if (!orderItemId) {
        return [];
      }
      return this.resolvedItems.filter(a => a.parentOrderItemId == orderItemId && a.isBundleComponent);
    },
    SplitItemIntoComponents(item) {
      let components = this.getBundleComponents(item.id);
      let index = this.itemForm.items.findIndex(a => a.id == item.id);
      if (index == -1 || !components.length) {
        return;
      }
      let totalComponentQty = components.reduce((sum, c) => sum + c.quantityToShip, 0);
      // keep the original line total, spread across the component units
      let unitPrice = totalComponentQty > 0
        ? Math.round(((parseFloat(item.unitPrice) || 0) * item.quantity / totalComponentQty) * 100) / 100
        : 0;
      let componentItems = components.map((comp, idx) => ({
        orderId: this.itemForm.id,
        orderItemId: 'itm' + new Date().getUTCMilliseconds() + '-' + idx,
        newItemToAdd: true,
        sku: comp.sku,
        name: comp.name,
        quantity: comp.quantityToShip,
        unitPrice: unitPrice,
        weight: { value: 0, units: 'ounces' },
        unitWeightOz: 0,
        productId: ''
      }));
      this.itemForm.items.splice(index, 1, ...componentItems);
    },
    getOrderStatus(order) {
      let stat = order.orderStatus;
      switch (stat) {
        case 'on_hold':
          return '<span class="badge badge-secondary">OnHold</span>';
        case 'open':
          return '<span class="badge badge-primary">Open</span>';
        case 'awaiting_shipment':
          return '<span class="badge badge-warning">Awaiting Shipment '+(order.sentToFulfillService ? ' [at fulfillment]' : '')+'</span>';
        case 'shipping':
          return '<span class="badge badge-warning">Shipping</span>';
        case 'shipped':
          return '<span class="badge badge-success">Shipped</span>';
        case 'cancelled':
          return '<span class="badge badge-danger">Canceled</span>';
        case 'awaiting_payment':
          return '<span class="badge badge-danger">Awaiting Payment</span>';
        case 'pending_fulfillment':
          return '<span class="badge badge-danger">Pending Fulfillment</span>';
        default:
          return '<span class="badge badge-primary">Open</span>';
      }
    },
    ViewShipmentItems(shipment) {
      this.activeShipment = shipment;
      this.shipmentItems = shipment.shipmentItems;
      this.showShipmentItemsModal = true;
    },
    markShipmentDelivered(shipment) {
      this.markingDeliveredShipmentId = shipment.id;
      this.$http.post('/api/common/storefrontShipments/markDelivered', { shipmentId: shipment.id })
        .then(response => {
          if (response.data && response.data.success) {
            this.$swal('Delivered!', 'Shipment has been marked as delivered.', 'success');
            this.loadItem();
          } else {
            this.$swal('Error', (response.data && response.data.errorMessage) || 'Failed to mark shipment as delivered.', 'error');
          }
        })
        .catch(error => {
          this.$swal('Error', (error.response && error.response.data && error.response.data.errorMessage) || 'An error occurred.', 'error');
        })
        .finally(() => {
          this.markingDeliveredShipmentId = null;
        });
    },


    // Optimal packaging box methods
    toggleOptimalBoxItems(index) {
      this.$set(this.optimalBoxItemsExpanded, index, !this.optimalBoxItemsExpanded[index]);
    },
    getOptimalPackagingBox() {
      this.loadingOptimalBox = true;
      this.optimalBoxError = null;
      this.optimalBoxResult = null;
      this.optimalBoxItemsExpanded = {}; // Reset expanded state

      let orderId = this.order.id;
      this.$http.get(`/api/common/storefront-orders/${orderId}/fulfillment/optimal-packaging-box`)
        .then(response => {
          this.optimalBoxResult = response.data;
          // Log for debugging
          if (this.optimalBoxResult && this.optimalBoxResult.recommendedBoxes) {
            console.log('Optimal packaging result:', this.optimalBoxResult);
            this.optimalBoxResult.recommendedBoxes.forEach((box, index) => {
              console.log(`Box ${index + 1}:`, box.name, 'Items:', box.items);
            });
          }
        })
        .catch(error => {
          console.error('Error getting optimal packaging box:', error);
          if (error.response && error.response.data && error.response.data.errorMessage) {
            this.optimalBoxError = error.response.data.errorMessage;
          } else {
            this.optimalBoxError = 'Failed to calculate optimal packaging box';
          }
        })
        .finally(() => {
          this.loadingOptimalBox = false;
        });
    },

    clearOptimalBoxResult() {
      this.optimalBoxResult = null;
      this.optimalBoxError = null;
      this.optimalBoxItemsExpanded = {}; // Reset expanded state
    },

    fetchOrderReturns() {
      if (!this.order || !this.order.id) return;

      this.loadingOrderReturns = true;
      this.orderReturnsError = null;

      const params = {
        orderNumber: this.order.orderNumber,
        orderId: this.order.id,
        page: 1,
        perPage: 5
      };

        this.$http.post('/api/common/orderReturns/listItems', params)
        .then(response => {
          if (response.data && response.data.items) {
            this.orderReturns = response.data.items || [];
          } else {
            this.orderReturnsError = (response.data && response.data.errorMessage) || 'Failed to load order returns';
          }
        })
        .catch(error => {
          console.error('Error fetching order returns:', error);
          this.orderReturnsError = (error.response && error.response.data && error.response.data.errorMessage) || 'An error occurred while loading order returns';
        })
        .finally(() => {
          this.loadingOrderReturns = false;
        });
    },
    validateShippingAddress() {
      this.validatingAddress = true;
      this.addressValidationResult = null;
      this.selectedCandidateId = null;
      this.showAddressValidationSidebar = true;
      this.$http
        .post(`/api/common/storefront-orders/${this.order.id}/validate-address`, {})
        .then(response => {
          this.addressValidationResult = response.data;
          if (response.data) {
            this.loadItem();
          }
        })
        .catch(error => {
          this.$swal('Error', (error.response && error.response.data && error.response.data.errorMessage) || 'Address validation failed.', 'error');
          this.showAddressValidationSidebar = false;
        })
        .finally(() => {
          this.validatingAddress = false;
        });
    },
    confirmAddressCorrection() {
      this.confirmingCorrection = true;
      this.$http
        .post(`/api/common/storefront-orders/${this.order.id}/validate-address`, {
          correctedAddressId: this.selectedCandidateId
        })
        .then(response => {
          this.addressValidationResult = response.data;
          if (response.data && response.data.wasUpdated) {
            if (response.data.newAddress) {
              this.order.shipTo.street1 = response.data.newAddress.street1;
              this.order.shipTo.street2 = response.data.newAddress.street2;
              this.order.shipTo.city = response.data.newAddress.city;
              this.order.shipTo.state = response.data.newAddress.stateProvince;
              this.order.shipTo.postalCode = response.data.newAddress.postalCode;
              this.order.shipTo.country = response.data.newAddress.countryCode;
              this.loadItem();
            }
          }
          this.selectedCandidateId = null;
        })
        .catch(error => {
          this.$swal('Error', (error.response && error.response.data && error.response.data.errorMessage) || 'Failed to apply correction.', 'error');
        })
        .finally(() => {
          this.confirmingCorrection = false;
        });
    }
  }
};
</script>
